// @format
/**
 * Backwards-compatibility shim for @dsg-tech/homefield-angular-icons v7 → v9.
 * Re-exports all v9 icons and provides old v7 export names so existing imports
 * and template name strings continue to work without modification.
 *
 * DO NOT import this file directly. It is aliased via tsconfig paths to
 * '@dsg-tech/homefield-angular-icons'. Use that import path instead.
 *
 * To migrate an icon to its v9 name, update the import to use the v9 export
 * name (e.g. homefieldIconOrderCartFill instead of homefieldIconOrderCartStandard)
 * and update any template [name] or [icon] strings accordingly.
 */

// Re-export everything from v9 — new names, new APIs, the full v9 surface
export * from './homefield-icons-raw';

// --- Renamed icons: old TS export name preserved, old template name string preserved ---
import {
  homefieldIconAiStarFill,
  homefieldIconAlertErrorFill,
  homefieldIconAlertErrorOutline,
  homefieldIconAlertHelpOutline,
  homefieldIconAlertInfoFill,
  homefieldIconAlertInfoOutline,
  homefieldIconAlertReportFill,
  homefieldIconAlertWarningFill,
  homefieldIconAlertWarningOutline,
  homefieldIconArrowBackspaceOutline,
  homefieldIconArrowDownOutline,
  homefieldIconArrowLeftOutline,
  homefieldIconArrowLoopClockwiseOutline,
  homefieldIconArrowOpenInNewOutline,
  homefieldIconArrowRefreshOutline,
  homefieldIconArrowReplayOutline,
  homefieldIconArrowRightOutline,
  homefieldIconArrowTrendFlatOutline,
  homefieldIconArrowUpBoxedOutline,
  homefieldIconBuildingStoreFill,
  homefieldIconCalendarDefaultOutline,
  homefieldIconCaretDownFill,
  homefieldIconChatLeftCommentFill,
  homefieldIconChevronDownOutline,
  homefieldIconChevronLeftOutline,
  homefieldIconChevronRightOutline,
  homefieldIconChevronUpOutline,
  homefieldIconDeleteFill,
  homefieldIconDeleteForeverFill,
  homefieldIconDeleteOutline,
  homefieldIconDeviceFill,
  homefieldIconFileCopyOutline,
  homefieldIconFileLinkOnOutline,
  homefieldIconFulfillmentAvailabilityFill,
  homefieldIconFulfillmentPickupFill,
  homefieldIconFulfillmentPickupOutline,
  homefieldIconFulfillmentSamedayFill,
  homefieldIconFulfillmentSamedayOutline,
  homefieldIconFulfillmentShippingFill,
  homefieldIconFulfillmentShippingOutline,
  homefieldIconGiftBoxOutline,
  homefieldIconListBulletOutline,
  homefieldIconListFilterOutline,
  homefieldIconListTuneOutline,
  homefieldIconLocationNearmeFill,
  homefieldIconLocationPinFill,
  homefieldIconLoyaltyRibbonFill,
  homefieldIconLoyaltyRibbonOutline,
  homefieldIconMailEnvelopeOutline,
  homefieldIconMediaPauseOutline,
  homefieldIconMediaPlayFill,
  homefieldIconMobileBarcodeScannerOutline,
  homefieldIconMobilePhoneFill,
  homefieldIconMobileQrcodeFill,
  homefieldIconMoneyCashOutline,
  homefieldIconMoneyCreditCardOutline,
  homefieldIconMoneyDollarSignOutline,
  homefieldIconMoneyGiftcardOutline,
  homefieldIconMoneyOfferFill,
  homefieldIconMoneyPaymentsAmexFill,
  homefieldIconMoneyPaymentsDiscoverFill,
  homefieldIconMoneyPaymentsMastercardFill,
  homefieldIconMoneyPaymentsPlccFill,
  homefieldIconMoneyPaymentsScorecardFill,
  homefieldIconMoneyPaymentsScorecardGoldFill,
  homefieldIconMoneyPaymentsVisaFill,
  homefieldIconNaturePlantFill,
  homefieldIconNatureWavesOutline,
  homefieldIconNotificationAddFill,
  homefieldIconOrderCartFill,
  homefieldIconOrderPackageOutline,
  homefieldIconPenEditFill,
  homefieldIconPhotoImagesFill,
  homefieldIconPhotoZoomOutline,
  homefieldIconPlCheckOutline,
  homefieldIconPlIconOutline,
  homefieldIconPlMediaPlayOutline,
  homefieldIconPlStoreOutline,
  homefieldIconPlTreeOutline,
  homefieldIconReactionDislikeFill,
  homefieldIconReactionLikeFill,
  homefieldIconReactionLoveEmptyFill,
  homefieldIconReactionLoveFill,
  homefieldIconReactionLoveOutline,
  homefieldIconRecommendationFireFill,
  homefieldIconSearchOutline,
  homefieldIconSecurityLockFill,
  homefieldIconSecurityLockUnlockedFill,
  homefieldIconSecurityVerifiedUserFill,
  homefieldIconSignAddOutline,
  homefieldIconSignCancelOutline,
  homefieldIconSignCheckFill,
  homefieldIconSignCircledAddFill,
  homefieldIconSignCircledCancelFill,
  homefieldIconSignCircledCancelOutline,
  homefieldIconSignCircledCheckFill,
  homefieldIconSignCircledSubtractFill,
  homefieldIconSportsGolfFill,
  homefieldIconSportsTrophyFill,
  homefieldIconStarCircleFill,
  homefieldIconStarFill,
  homefieldIconStarOutline,
  homefieldIconStarRatingFill0Percent,
  homefieldIconStarRatingFill100Percent,
  homefieldIconStarRatingFill25Percent,
  homefieldIconStarRatingFill50Percent,
  homefieldIconStarRatingFill75Percent,
  homefieldIconTimeClockFill,
  homefieldIconToolGearFill,
  homefieldIconToolStraightenOutline,
  homefieldIconUserBoxFill,
  homefieldIconUserBoxOutline,
  homefieldIconUserGroupFill,
} from './homefield-icons-raw';

/** @deprecated Use `homefieldIconAiStarFill` (v9). Old template name `ai-star` is preserved. */
export const homefieldIconAiStar = { ...homefieldIconAiStarFill, name: 'ai-star' as const };
/** @deprecated Use `homefieldIconAlertErrorFill` (v9). Old template name `alert-error-filled` is preserved. */
export const homefieldIconAlertErrorFilled = {
  ...homefieldIconAlertErrorFill,
  name: 'alert-error-filled' as const,
};
/** @deprecated Use `homefieldIconAlertErrorOutline` (v9). Old template name `alert-error-outlined` is preserved. */
export const homefieldIconAlertErrorOutlined = {
  ...homefieldIconAlertErrorOutline,
  name: 'alert-error-outlined' as const,
};
/** @deprecated Use `homefieldIconAlertHelpOutline` (v9). Old template name `alert-help-outlined` is preserved. */
export const homefieldIconAlertHelpOutlined = {
  ...homefieldIconAlertHelpOutline,
  name: 'alert-help-outlined' as const,
};
/** @deprecated Use `homefieldIconAlertInfoFill` (v9). Old template name `alert-info-filled` is preserved. */
export const homefieldIconAlertInfoFilled = {
  ...homefieldIconAlertInfoFill,
  name: 'alert-info-filled' as const,
};
/** @deprecated Use `homefieldIconAlertInfoOutline` (v9). Old template name `alert-info-outlined` is preserved. */
export const homefieldIconAlertInfoOutlined = {
  ...homefieldIconAlertInfoOutline,
  name: 'alert-info-outlined' as const,
};
/** @deprecated Use `homefieldIconAlertReportFill` (v9). Old template name `alert-report-filled` is preserved. */
export const homefieldIconAlertReportFilled = {
  ...homefieldIconAlertReportFill,
  name: 'alert-report-filled' as const,
};
/** @deprecated Use `homefieldIconAlertWarningFill` (v9). Old template name `alert-warning-filled` is preserved. */
export const homefieldIconAlertWarningFilled = {
  ...homefieldIconAlertWarningFill,
  name: 'alert-warning-filled' as const,
};
/** @deprecated Use `homefieldIconAlertWarningOutline` (v9). Old template name `alert-warning-outlined` is preserved. */
export const homefieldIconAlertWarningOutlined = {
  ...homefieldIconAlertWarningOutline,
  name: 'alert-warning-outlined' as const,
};
/** @deprecated Use `homefieldIconArrowBackspaceOutline` (v9). Old template name `arrow-backspace` is preserved. */
export const homefieldIconArrowBackspace = {
  ...homefieldIconArrowBackspaceOutline,
  name: 'arrow-backspace' as const,
};
/** @deprecated Use `homefieldIconArrowDownOutline` (v9). Old template name `arrow-down` is preserved. */
export const homefieldIconArrowDown = {
  ...homefieldIconArrowDownOutline,
  name: 'arrow-down' as const,
};
/** @deprecated Use `homefieldIconArrowLeftOutline` (v9). Old template name `arrow-left` is preserved. */
export const homefieldIconArrowLeft = {
  ...homefieldIconArrowLeftOutline,
  name: 'arrow-left' as const,
};
/** @deprecated Use `homefieldIconArrowLoopClockwiseOutline` (v9). Old template name `arrow-loop-cw` is preserved. */
export const homefieldIconArrowLoopCw = {
  ...homefieldIconArrowLoopClockwiseOutline,
  name: 'arrow-loop-cw' as const,
};
/** @deprecated Use `homefieldIconArrowOpenInNewOutline` (v9). Old template name `arrow-up-right-boxed` is preserved. */
export const homefieldIconArrowUpRightBoxed = {
  ...homefieldIconArrowOpenInNewOutline,
  name: 'arrow-up-right-boxed' as const,
};
/** @deprecated Use `homefieldIconArrowRefreshOutline` (v9). Old template name `arrow-refresh` is preserved. */
export const homefieldIconArrowRefresh = {
  ...homefieldIconArrowRefreshOutline,
  name: 'arrow-refresh' as const,
};
/** @deprecated Use `homefieldIconArrowReplayOutline` (v9). Old template name `arrow-replay` is preserved. */
export const homefieldIconArrowReplay = {
  ...homefieldIconArrowReplayOutline,
  name: 'arrow-replay' as const,
};
/** @deprecated Use `homefieldIconArrowRightOutline` (v9). Old template name `arrow-right` is preserved. */
export const homefieldIconArrowRight = {
  ...homefieldIconArrowRightOutline,
  name: 'arrow-right' as const,
};
/** @deprecated Use `homefieldIconArrowRightOutline` (v9). Old template name `navigation-arrow-forward` is preserved. */
export const homefieldIconNavigationArrowForward = {
  ...homefieldIconArrowRightOutline,
  name: 'navigation-arrow-forward' as const,
};
/** @deprecated Use `homefieldIconArrowTrendFlatOutline` (v9). Old template name `arrow-trend-flat` is preserved. */
export const homefieldIconArrowTrendFlat = {
  ...homefieldIconArrowTrendFlatOutline,
  name: 'arrow-trend-flat' as const,
};
/** @deprecated Use `homefieldIconArrowUpBoxedOutline` (v9). Old template name `arrow-up-boxed` is preserved. */
export const homefieldIconArrowUpBoxed = {
  ...homefieldIconArrowUpBoxedOutline,
  name: 'arrow-up-boxed' as const,
};
/** @deprecated Use `homefieldIconBuildingStoreFill` (v9). Old template name `building-store` is preserved. */
export const homefieldIconBuildingStore = {
  ...homefieldIconBuildingStoreFill,
  name: 'building-store' as const,
};
/** @deprecated Use `homefieldIconCalendarDefaultOutline` (v9). Old template name `calendar-default` is preserved. */
export const homefieldIconCalendarDefault = {
  ...homefieldIconCalendarDefaultOutline,
  name: 'calendar-default' as const,
};
/** @deprecated Use `homefieldIconCaretDownFill` (v9). Old template name `caret-down` is preserved. */
export const homefieldIconCaretDown = {
  ...homefieldIconCaretDownFill,
  name: 'caret-down' as const,
};
/** @deprecated Use `homefieldIconChatLeftCommentFill` (v9). Old template name `chat-left-comment` is preserved. */
export const homefieldIconChatLeftComment = {
  ...homefieldIconChatLeftCommentFill,
  name: 'chat-left-comment' as const,
};
/** @deprecated Use `homefieldIconChevronDownOutline` (v9). Old template name `chevron-down` is preserved. */
export const homefieldIconChevronDown = {
  ...homefieldIconChevronDownOutline,
  name: 'chevron-down' as const,
};
/** @deprecated Use `homefieldIconChevronLeftOutline` (v9). Old template name `chevron-left` is preserved. */
export const homefieldIconChevronLeft = {
  ...homefieldIconChevronLeftOutline,
  name: 'chevron-left' as const,
};
/** @deprecated Use `homefieldIconChevronRightOutline` (v9). Old template name `chevron-right` is preserved. */
export const homefieldIconChevronRight = {
  ...homefieldIconChevronRightOutline,
  name: 'chevron-right' as const,
};
/** @deprecated Use `homefieldIconChevronUpOutline` (v9). Old template name `chevron-up` is preserved. */
export const homefieldIconChevronUp = {
  ...homefieldIconChevronUpOutline,
  name: 'chevron-up' as const,
};
/** @deprecated Use `homefieldIconDeleteFill` (v9). Old template name `delete-filled` is preserved. */
export const homefieldIconDeleteFilled = {
  ...homefieldIconDeleteFill,
  name: 'delete-filled' as const,
};
/** @deprecated Use `homefieldIconDeleteForeverFill` (v9). Old template name `delete-forever` is preserved. */
export const homefieldIconDeleteForever = {
  ...homefieldIconDeleteForeverFill,
  name: 'delete-forever' as const,
};
/** @deprecated Use `homefieldIconDeleteOutline` (v9). Old template name `delete-outlined` is preserved. */
export const homefieldIconDeleteOutlined = {
  ...homefieldIconDeleteOutline,
  name: 'delete-outlined' as const,
};
/** @deprecated Use `homefieldIconDeviceFill` (v9). Old template name `device` is preserved. */
export const homefieldIconDevice = { ...homefieldIconDeviceFill, name: 'device' as const };
/** @deprecated Use `homefieldIconFileCopyOutline` (v9). Old template name `file-copy` is preserved. */
export const homefieldIconFileCopy = {
  ...homefieldIconFileCopyOutline,
  name: 'file-copy' as const,
};
/** @deprecated Use `homefieldIconFileLinkOnOutline` (v9). Old template name `file-link` is preserved. */
export const homefieldIconFileLink = {
  ...homefieldIconFileLinkOnOutline,
  name: 'file-link' as const,
};
/** @deprecated Use `homefieldIconFulfillmentAvailabilityFill` (v9). Old template name `availability-dot-filled` is preserved. */
export const homefieldIconAvailabilityDotFilled = {
  ...homefieldIconFulfillmentAvailabilityFill,
  name: 'availability-dot-filled' as const,
};
/** @deprecated Use `homefieldIconFulfillmentPickupFill` (v9). Old template name `building-store-dsg-alt` is preserved. */
export const homefieldIconBuildingStoreDsgAlt = {
  ...homefieldIconFulfillmentPickupFill,
  name: 'building-store-dsg-alt' as const,
};
/** @deprecated Use `homefieldIconFulfillmentPickupFill` (v9). Old template name `fulfillment-pickup-filled` is preserved. */
export const homefieldIconFulfillmentPickupFilled = {
  ...homefieldIconFulfillmentPickupFill,
  name: 'fulfillment-pickup-filled' as const,
};
/** @deprecated Use `homefieldIconFulfillmentPickupOutline` (v9). Old template name `fulfillment-pickup-outlined` is preserved. */
export const homefieldIconFulfillmentPickupOutlined = {
  ...homefieldIconFulfillmentPickupOutline,
  name: 'fulfillment-pickup-outlined' as const,
};
/** @deprecated Use `homefieldIconFulfillmentSamedayFill` (v9). Old template name `fulfillment-sameday-filled` is preserved. */
export const homefieldIconFulfillmentSamedayFilled = {
  ...homefieldIconFulfillmentSamedayFill,
  name: 'fulfillment-sameday-filled' as const,
};
/** @deprecated Use `homefieldIconFulfillmentSamedayFill` (v9). Old template name `order-delivery` is preserved. */
export const homefieldIconOrderDelivery = {
  ...homefieldIconFulfillmentSamedayFill,
  name: 'order-delivery' as const,
};
/** @deprecated Use `homefieldIconFulfillmentSamedayOutline` (v9). Old template name `fulfillment-sameday-outlined` is preserved. */
export const homefieldIconFulfillmentSamedayOutlined = {
  ...homefieldIconFulfillmentSamedayOutline,
  name: 'fulfillment-sameday-outlined' as const,
};
/** @deprecated Use `homefieldIconFulfillmentShippingFill` (v9). Old template name `fulfillment-shipping-filled` is preserved. */
export const homefieldIconFulfillmentShippingFilled = {
  ...homefieldIconFulfillmentShippingFill,
  name: 'fulfillment-shipping-filled' as const,
};
/** @deprecated Use `homefieldIconFulfillmentShippingFill` (v9). Old template name `vehicle-shipping` is preserved. */
export const homefieldIconVehicleShipping = {
  ...homefieldIconFulfillmentShippingFill,
  name: 'vehicle-shipping' as const,
};
/** @deprecated Use `homefieldIconFulfillmentShippingOutline` (v9). Old template name `fulfillment-shipping-outlined` is preserved. */
export const homefieldIconFulfillmentShippingOutlined = {
  ...homefieldIconFulfillmentShippingOutline,
  name: 'fulfillment-shipping-outlined' as const,
};
/** @deprecated Use `homefieldIconGiftBoxOutline` (v9). Old template name `gift-box` is preserved. */
export const homefieldIconGiftBox = { ...homefieldIconGiftBoxOutline, name: 'gift-box' as const };
/** @deprecated Use `homefieldIconListBulletOutline` (v9). Old template name `list-bullet` is preserved. */
export const homefieldIconListBullet = {
  ...homefieldIconListBulletOutline,
  name: 'list-bullet' as const,
};
/** @deprecated Use `homefieldIconListFilterOutline` (v9). Old template name `list-filter` is preserved. */
export const homefieldIconListFilter = {
  ...homefieldIconListFilterOutline,
  name: 'list-filter' as const,
};
/** @deprecated Use `homefieldIconListTuneOutline` (v9). Old template name `list-tune` is preserved. */
export const homefieldIconListTune = {
  ...homefieldIconListTuneOutline,
  name: 'list-tune' as const,
};
/** @deprecated Use `homefieldIconLocationNearmeFill` (v9). Old template name `location-nearme` is preserved. */
export const homefieldIconLocationNearme = {
  ...homefieldIconLocationNearmeFill,
  name: 'location-nearme' as const,
};
/** @deprecated Use `homefieldIconLocationPinFill` (v9). Old template name `location-pin-filled` is preserved. */
export const homefieldIconLocationPinFilled = {
  ...homefieldIconLocationPinFill,
  name: 'location-pin-filled' as const,
};
/** @deprecated Use `homefieldIconLocationPinFill` (v9). Old template name `location-pin-filled-new` is preserved. */
export const homefieldIconLocationPinFilledNew = {
  ...homefieldIconLocationPinFill,
  name: 'location-pin-filled-new' as const,
};
/** @deprecated Use `homefieldIconLoyaltyRibbonFill` (v9). Old template name `ribbon` is preserved. */
export const homefieldIconRibbon = { ...homefieldIconLoyaltyRibbonFill, name: 'ribbon' as const };
/** @deprecated Use `homefieldIconLoyaltyRibbonOutline` (v9). Old template name `loyalty-ribbon-outlined` is preserved. */
export const homefieldIconLoyaltyRibbonOutlined = {
  ...homefieldIconLoyaltyRibbonOutline,
  name: 'loyalty-ribbon-outlined' as const,
};
/** @deprecated Use `homefieldIconMailEnvelopeOutline` (v9). Old template name `mail-envelope-outlined` is preserved. */
export const homefieldIconMailEnvelopeOutlined = {
  ...homefieldIconMailEnvelopeOutline,
  name: 'mail-envelope-outlined' as const,
};
/** @deprecated Use `homefieldIconMediaPauseOutline` (v9). Old template name `media-pause` is preserved. */
export const homefieldIconMediaPause = {
  ...homefieldIconMediaPauseOutline,
  name: 'media-pause' as const,
};
/** @deprecated Use `homefieldIconMediaPlayFill` (v9). Old template name `media-play` is preserved. */
export const homefieldIconMediaPlay = {
  ...homefieldIconMediaPlayFill,
  name: 'media-play' as const,
};
/** @deprecated Use `homefieldIconMobileBarcodeScannerOutline` (v9). Old template name `mobile-barcode-off` is preserved. */
export const homefieldIconMobileBarcodeOff = {
  ...homefieldIconMobileBarcodeScannerOutline,
  name: 'mobile-barcode-off' as const,
};
/** @deprecated Use `homefieldIconMobilePhoneFill` (v9). Old template name `mobile-phone` is preserved. */
export const homefieldIconMobilePhone = {
  ...homefieldIconMobilePhoneFill,
  name: 'mobile-phone' as const,
};
/** @deprecated Use `homefieldIconMobileQrcodeFill` (v9). Old template name `mobile-qr-code` is preserved. */
export const homefieldIconMobileQrCode = {
  ...homefieldIconMobileQrcodeFill,
  name: 'mobile-qr-code' as const,
};
/** @deprecated Use `homefieldIconMoneyCashOutline` (v9). Old template name `money-cash` is preserved. */
export const homefieldIconMoneyCash = {
  ...homefieldIconMoneyCashOutline,
  name: 'money-cash' as const,
};
/** @deprecated Use `homefieldIconMoneyCreditCardOutline` (v9). Old template name `money-creditcard` is preserved. */
export const homefieldIconMoneyCreditcard = {
  ...homefieldIconMoneyCreditCardOutline,
  name: 'money-creditcard' as const,
};
/** @deprecated Use `homefieldIconMoneyDollarSignOutline` (v9). Old template name `money-dollarsign` is preserved. */
export const homefieldIconMoneyDollarsign = {
  ...homefieldIconMoneyDollarSignOutline,
  name: 'money-dollarsign' as const,
};
/** @deprecated Use `homefieldIconMoneyGiftcardOutline` (v9). Old template name `money-giftcard` is preserved. */
export const homefieldIconMoneyGiftcard = {
  ...homefieldIconMoneyGiftcardOutline,
  name: 'money-giftcard' as const,
};
/** @deprecated Use `homefieldIconMoneyOfferFill` (v9). Old template name `offer` is preserved. */
export const homefieldIconOffer = { ...homefieldIconMoneyOfferFill, name: 'offer' as const };
/** @deprecated Use `homefieldIconMoneyPaymentsAmexFill` (v9). Old template name `money-creditcard-amex` is preserved. */
export const homefieldIconMoneyCreditcardAmex = {
  ...homefieldIconMoneyPaymentsAmexFill,
  name: 'money-creditcard-amex' as const,
};
/** @deprecated Use `homefieldIconMoneyPaymentsDiscoverFill` (v9). Old template name `money-creditcard-discover` is preserved. */
export const homefieldIconMoneyCreditcardDiscover = {
  ...homefieldIconMoneyPaymentsDiscoverFill,
  name: 'money-creditcard-discover' as const,
};
/** @deprecated Use `homefieldIconMoneyPaymentsMastercardFill` (v9). Old template name `money-creditcard-mastercard` is preserved. */
export const homefieldIconMoneyCreditcardMastercard = {
  ...homefieldIconMoneyPaymentsMastercardFill,
  name: 'money-creditcard-mastercard' as const,
};
/** @deprecated Use `homefieldIconMoneyPaymentsPlccFill` (v9). Old template name `money-creditcard-plcc` is preserved. */
export const homefieldIconMoneyCreditcardPlcc = {
  ...homefieldIconMoneyPaymentsPlccFill,
  name: 'money-creditcard-plcc' as const,
};
/** @deprecated Use `homefieldIconMoneyPaymentsScorecardFill` (v9). Old template name `money-scorecard` is preserved. */
export const homefieldIconMoneyScorecard = {
  ...homefieldIconMoneyPaymentsScorecardFill,
  name: 'money-scorecard' as const,
};
/** @deprecated Use `homefieldIconMoneyPaymentsScorecardGoldFill` (v9). Old template name `money-scorecard-gold` is preserved. */
export const homefieldIconMoneyScorecardGold = {
  ...homefieldIconMoneyPaymentsScorecardGoldFill,
  name: 'money-scorecard-gold' as const,
};
/** @deprecated Use `homefieldIconMoneyPaymentsVisaFill` (v9). Old template name `money-creditcard-visa` is preserved. */
export const homefieldIconMoneyCreditcardVisa = {
  ...homefieldIconMoneyPaymentsVisaFill,
  name: 'money-creditcard-visa' as const,
};
/** @deprecated Use `homefieldIconNaturePlantFill` (v9). Old template name `nature-plant` is preserved. */
export const homefieldIconNaturePlant = {
  ...homefieldIconNaturePlantFill,
  name: 'nature-plant' as const,
};
/** @deprecated Use `homefieldIconNatureWavesOutline` (v9). Old template name `nature-waves` is preserved. */
export const homefieldIconNatureWaves = {
  ...homefieldIconNatureWavesOutline,
  name: 'nature-waves' as const,
};
/** @deprecated Use `homefieldIconNotificationAddFill` (v9). Old template name `notification-add` is preserved. */
export const homefieldIconNotificationAdd = {
  ...homefieldIconNotificationAddFill,
  name: 'notification-add' as const,
};
/** @deprecated Use `homefieldIconOrderCartFill` (v9). Old template name `order-cart-standard` is preserved. */
export const homefieldIconOrderCartStandard = {
  ...homefieldIconOrderCartFill,
  name: 'order-cart-standard' as const,
};
/** @deprecated Use `homefieldIconOrderPackageOutline` (v9). Old template name `order-package` is preserved. */
export const homefieldIconOrderPackage = {
  ...homefieldIconOrderPackageOutline,
  name: 'order-package' as const,
};
/** @deprecated Use `homefieldIconPenEditFill` (v9). Old template name `pen-edit` is preserved. */
export const homefieldIconPenEdit = { ...homefieldIconPenEditFill, name: 'pen-edit' as const };
/** @deprecated Use `homefieldIconPhotoImagesFill` (v9). Old template name `photo-images-filled` is preserved. */
export const homefieldIconPhotoImagesFilled = {
  ...homefieldIconPhotoImagesFill,
  name: 'photo-images-filled' as const,
};
/** @deprecated Use `homefieldIconPhotoZoomOutline` (v9). Old template name `zoom-image` is preserved. */
export const homefieldIconZoomImage = {
  ...homefieldIconPhotoZoomOutline,
  name: 'zoom-image' as const,
};
/** @deprecated Use `homefieldIconPlCheckOutline` (v9). Old template name `pl-check` is preserved. */
export const homefieldIconPlCheck = { ...homefieldIconPlCheckOutline, name: 'pl-check' as const };
/** @deprecated Use `homefieldIconPlIconOutline` (v9). Old template name `pl-icon` is preserved. */
export const homefieldIconPlIcon = { ...homefieldIconPlIconOutline, name: 'pl-icon' as const };
/** @deprecated Use `homefieldIconPlMediaPlayOutline` (v9). Old template name `pl-media-play` is preserved. */
export const homefieldIconPlMediaPlay = {
  ...homefieldIconPlMediaPlayOutline,
  name: 'pl-media-play' as const,
};
/** @deprecated Use `homefieldIconPlStoreOutline` (v9). Old template name `pl-store` is preserved. */
export const homefieldIconPlStore = { ...homefieldIconPlStoreOutline, name: 'pl-store' as const };
/** @deprecated Use `homefieldIconPlTreeOutline` (v9). Old template name `pl-tree` is preserved. */
export const homefieldIconPlTree = { ...homefieldIconPlTreeOutline, name: 'pl-tree' as const };
/** @deprecated Use `homefieldIconReactionDislikeFill` (v9). Old template name `reaction-dislike` is preserved. */
export const homefieldIconReactionDislike = {
  ...homefieldIconReactionDislikeFill,
  name: 'reaction-dislike' as const,
};
/** @deprecated Use `homefieldIconReactionLikeFill` (v9). Old template name `reaction-like` is preserved. */
export const homefieldIconReactionLike = {
  ...homefieldIconReactionLikeFill,
  name: 'reaction-like' as const,
};
/** @deprecated Use `homefieldIconReactionLoveEmptyFill` (v9). Old template name `reaction-love-empty` is preserved. */
export const homefieldIconReactionLoveEmpty = {
  ...homefieldIconReactionLoveEmptyFill,
  name: 'reaction-love-empty' as const,
};
/** @deprecated Use `homefieldIconReactionLoveFill` (v9). Old template name `reaction-love-filled` is preserved. */
export const homefieldIconReactionLoveFilled = {
  ...homefieldIconReactionLoveFill,
  name: 'reaction-love-filled' as const,
};
/** @deprecated Use `homefieldIconReactionLoveOutline` (v9). Old template name `reaction-love-outlined` is preserved. */
export const homefieldIconReactionLoveOutlined = {
  ...homefieldIconReactionLoveOutline,
  name: 'reaction-love-outlined' as const,
};
/** @deprecated Use `homefieldIconRecommendationFireFill` (v9). Old template name `recommendation-fire` is preserved. */
export const homefieldIconRecommendationFire = {
  ...homefieldIconRecommendationFireFill,
  name: 'recommendation-fire' as const,
};
/** @deprecated Use `homefieldIconSearchOutline` (v9). Old template name `search` is preserved. */
export const homefieldIconSearch = { ...homefieldIconSearchOutline, name: 'search' as const };
/** @deprecated Use `homefieldIconSecurityLockFill` (v9). Old template name `security-lock-locked-filled` is preserved. */
export const homefieldIconSecurityLockLockedFilled = {
  ...homefieldIconSecurityLockFill,
  name: 'security-lock-locked-filled' as const,
};
/** @deprecated Use `homefieldIconSecurityLockUnlockedFill` (v9). Old template name `security-lock-unlocked-filled` is preserved. */
export const homefieldIconSecurityLockUnlockedFilled = {
  ...homefieldIconSecurityLockUnlockedFill,
  name: 'security-lock-unlocked-filled' as const,
};
/** @deprecated Use `homefieldIconSecurityVerifiedUserFill` (v9). Old template name `security-verified-user` is preserved. */
export const homefieldIconSecurityVerifiedUser = {
  ...homefieldIconSecurityVerifiedUserFill,
  name: 'security-verified-user' as const,
};
/** @deprecated Use `homefieldIconSignAddOutline` (v9). Old template name `sign-add` is preserved. */
export const homefieldIconSignAdd = { ...homefieldIconSignAddOutline, name: 'sign-add' as const };
/** @deprecated Use `homefieldIconSignCancelOutline` (v9). Old template name `sign-cancel` is preserved. */
export const homefieldIconSignCancel = {
  ...homefieldIconSignCancelOutline,
  name: 'sign-cancel' as const,
};
/** @deprecated Use `homefieldIconSignCheckFill` (v9). Old template name `sign-check` is preserved. */
export const homefieldIconSignCheck = {
  ...homefieldIconSignCheckFill,
  name: 'sign-check' as const,
};
/** @deprecated Use `homefieldIconSignCircledAddFill` (v9). Old template name `sign-circled-add-filled` is preserved. */
export const homefieldIconSignCircledAddFilled = {
  ...homefieldIconSignCircledAddFill,
  name: 'sign-circled-add-filled' as const,
};
/** @deprecated Use `homefieldIconSignCircledCancelFill` (v9). Old template name `sign-circled-cancel-filled` is preserved. */
export const homefieldIconSignCircledCancelFilled = {
  ...homefieldIconSignCircledCancelFill,
  name: 'sign-circled-cancel-filled' as const,
};
/** @deprecated Use `homefieldIconSignCircledCancelOutline` (v9). Old template name `sign-circled-cancel-outlined` is preserved. */
export const homefieldIconSignCircledCancelOutlined = {
  ...homefieldIconSignCircledCancelOutline,
  name: 'sign-circled-cancel-outlined' as const,
};
/** @deprecated Use `homefieldIconSignCircledCheckFill` (v9). Old template name `sign-check-circle-filled` is preserved. */
export const homefieldIconSignCheckCircleFilled = {
  ...homefieldIconSignCircledCheckFill,
  name: 'sign-check-circle-filled' as const,
};
/** @deprecated Use `homefieldIconSignCircledCheckFill` (v9). Old template name `sign-circled-check` is preserved. */
export const homefieldIconSignCircledCheck = {
  ...homefieldIconSignCircledCheckFill,
  name: 'sign-circled-check' as const,
};
/** @deprecated Use `homefieldIconSignCircledSubtractFill` (v9). Old template name `sign-circled-subtract-filled` is preserved. */
export const homefieldIconSignCircledSubtractFilled = {
  ...homefieldIconSignCircledSubtractFill,
  name: 'sign-circled-subtract-filled' as const,
};
/** @deprecated Use `homefieldIconSportsGolfFill` (v9). Old template name `sports-golf` is preserved. */
export const homefieldIconSportsGolf = {
  ...homefieldIconSportsGolfFill,
  name: 'sports-golf' as const,
};
/** @deprecated Use `homefieldIconSportsTrophyFill` (v9). Old template name `sports-trophy` is preserved. */
export const homefieldIconSportsTrophy = {
  ...homefieldIconSportsTrophyFill,
  name: 'sports-trophy' as const,
};
/** @deprecated Use `homefieldIconStarCircleFill` (v9). Old template name `star-circle` is preserved. */
export const homefieldIconStarCircle = {
  ...homefieldIconStarCircleFill,
  name: 'star-circle' as const,
};
/** @deprecated Use `homefieldIconStarFill` (v9). Old template name `star-filled` is preserved. */
export const homefieldIconStarFilled = {
  ...homefieldIconStarFill,
  name: 'star-filled' as const
};
/** @deprecated Use `homefieldIconStarHalfFill` (v9). Old template name `star-half` is preserved. */
export const homefieldIconStarHalf = {
  ...homefieldIconStarRatingFill50Percent,
  name: 'star-half' as const,
};
/** @deprecated Use `homefieldIconStarRatingFill100Percent` (v9). Old template name `star-filled-100percent` is preserved. */
export const homefieldIconStarFilled100Percent = {
  ...homefieldIconStarRatingFill100Percent,
  name: 'star-filled-100percent' as const,
};
/** @deprecated Use `homefieldIconStarRatingFill75Percent` (v9). Old template name `star-filled-75percent` is preserved. */
export const homefieldIconStarFilled75Percent = {
  ...homefieldIconStarRatingFill75Percent,
  name: 'star-filled-75percent' as const,
};
/** @deprecated Use `homefieldIconStarRatingFill50Percent` (v9). Old template name `star-filled-50percent` is preserved. */
export const homefieldIconStarFilled50Percent = {
  ...homefieldIconStarRatingFill50Percent,
  name: 'star-filled-50percent' as const,
};
/** @deprecated Use `homefieldIconStarRatingFill25Percent` (v9). Old template name `star-filled-25percent` is preserved. */
export const homefieldIconStarFilled25Percent = {
  ...homefieldIconStarRatingFill25Percent,
  name: 'star-filled-25percent' as const,
};
/** @deprecated Use `homefieldIconStarOutline` (v9). Old template name `star-outlined` is preserved. */
export const homefieldIconStarOutlined = {
  ...homefieldIconStarOutline,
  name: 'star-outlined' as const,
};
/** @deprecated Use `homefieldIconStarRatingFill0Percent` (v9). Old template name `star-rating-fill-0percent` is preserved. */
export const homefieldIconStarFilled0Percent = {
  ...homefieldIconStarRatingFill0Percent,
  name: 'star-rating-fill-0percent' as const,
};
/** @deprecated Use `homefieldIconTimeClockFill` (v9). Old template name `time-clock-filled` is preserved. */
export const homefieldIconTimeClockFilled = {
  ...homefieldIconTimeClockFill,
  name: 'time-clock-filled' as const,
};
/** @deprecated Use `homefieldIconToolGearFill` (v9). Old template name `tool-gear` is preserved. */
export const homefieldIconToolGear = { ...homefieldIconToolGearFill, name: 'tool-gear' as const };
/** @deprecated Use `homefieldIconToolStraightenOutline` (v9). Old template name `tool-straighten` is preserved. */
export const homefieldIconToolStraighten = {
  ...homefieldIconToolStraightenOutline,
  name: 'tool-straighten' as const,
};
/** @deprecated Use `homefieldIconUserBoxFill` (v9). Old template name `user-box-filled` is preserved. */
export const homefieldIconUserBoxFilled = {
  ...homefieldIconUserBoxFill,
  name: 'user-box-filled' as const,
};
/** @deprecated Use `homefieldIconUserBoxOutline` (v9). Old template name `user-box-outlined` is preserved. */
export const homefieldIconUserBoxOutlined = {
  ...homefieldIconUserBoxOutline,
  name: 'user-box-outlined' as const,
};
/** @deprecated Use `homefieldIconUserGroupFill` (v9). Old template name `user-group` is preserved. */
export const homefieldIconUserGroup = {
  ...homefieldIconUserGroupFill,
  name: 'user-group' as const,
};

// --- Icons removed from v9: SVG data embedded from v7 to avoid breakage ---
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconAfterpay = {
  name: 'afterpay',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="130" height="32" fill="none" viewBox="0 0 130 32">
  <path fill="#00D633" fill-rule="evenodd" d="M11.149.03c-3.209 0-4.814 0-6.53.533A6.79 6.79 0 0 0 .55 4.636C.002 6.37.002 7.972.002 11.182v9.684c0 3.227 0 4.817.534 6.546a6.8 6.8 0 0 0 4.07 4.072c1.731.549 3.334.549 6.543.549h9.695c3.212 0 4.814 0 6.541-.55a6.79 6.79 0 0 0 4.07-4.071c.547-1.733.547-3.336.547-6.546v-9.67c0-3.214 0-4.818-.546-6.546a6.8 6.8 0 0 0-4.07-4.072c-1.744-.55-3.33-.55-6.558-.55h-9.68z" clip-rule="evenodd"/>
  <path fill="#fff" d="M17.297 14.477c3.372.722 4.913 2.119 4.913 4.48 0 2.958-2.41 5.142-6.17 5.373l-.367 1.75a.37.37 0 0 1-.362.294h-2.893a.37.37 0 0 1-.36-.455l.465-1.957c-1.865-.53-3.365-1.562-4.24-2.836a.37.37 0 0 1 .08-.499l2.023-1.573a.37.37 0 0 1 .529.08c1.072 1.492 2.716 2.375 4.696 2.375 1.782 0 3.131-.867 3.131-2.12 0-.963-.674-1.396-2.938-1.878-3.902-.819-5.443-2.264-5.443-4.624 0-2.739 2.301-4.807 5.773-5.076l.379-1.808a.37.37 0 0 1 .361-.293h2.855a.37.37 0 0 1 .361.447l-.439 2.026c1.494.46 2.71 1.282 3.468 2.297a.37.37 0 0 1-.065.504l-1.845 1.513a.37.37 0 0 1-.525-.059c-.937-1.16-2.414-1.815-4.013-1.815-1.782 0-2.89.77-2.89 1.879 0 .915.867 1.396 3.516 1.974"/>
  <path fill="#000" d="M50.486 8.225a.37.37 0 0 0-.346-.24h-3.003a.37.37 0 0 0-.346.24L41.005 23.61a.37.37 0 0 0 .346.5h2.275a.37.37 0 0 0 .346-.241l1.236-3.33h6.805l1.246 3.33a.37.37 0 0 0 .346.24h2.332a.37.37 0 0 0 .346-.5zm-4.29 9.653 2.392-6.468 2.425 6.468zM70.915 21.681a8 8 0 0 1-.69.026c-.942 0-1.526-.123-1.526-1.156v-5.783h2.067a.37.37 0 0 0 .37-.37v-1.72a.37.37 0 0 0-.37-.37h-2.067V9.265a.37.37 0 0 0-.37-.369h-2.136a.37.37 0 0 0-.369.37v3.044h-4.66v-.517c0-1.258.55-1.56 1.572-1.56.174 0 .303 0 .43.002a.37.37 0 0 0 .379-.369V8.132a.37.37 0 0 0-.352-.37c-.284-.012-.496-.012-.816-.012-2.774 0-4.132 1.38-4.132 3.851v.708h-1.248a.37.37 0 0 0-.37.37v1.72c0 .204.166.369.37.369h1.248v8.973c0 .204.165.37.369.37h2.18a.37.37 0 0 0 .37-.37v-8.973h4.66v6.322c0 2.414 1.235 3.155 3.549 3.155.602 0 1.16-.044 1.631-.115a.37.37 0 0 0 .311-.365v-1.716a.37.37 0 0 0-.4-.368M78.243 12.084c-3.312 0-5.682 2.662-5.682 6.131 0 3.65 2.37 6.143 5.795 6.143 2.217 0 4.058-1.083 4.97-2.968a.37.37 0 0 0-.208-.503l-1.769-.648a.367.367 0 0 0-.462.192c-.433.974-1.37 1.49-2.52 1.49-1.64 0-2.796-1.157-3.01-3.066h7.828a.37.37 0 0 0 .37-.37v-.54c0-3.267-1.853-5.86-5.312-5.86m-2.762 4.694c.393-1.516 1.415-2.302 2.74-2.302 1.617 0 2.392 1.067 2.414 2.302zM92.14 12.256a6 6 0 0 0-.422-.015c-1.482 0-2.672.708-3.189 1.775v-1.338a.37.37 0 0 0-.37-.37h-2.18a.37.37 0 0 0-.37.37v11.063c0 .204.166.37.37.37h2.18a.37.37 0 0 0 .37-.37v-5.728c0-1.853 1.28-2.908 2.953-2.908.226 0 .412.008.598.023a.37.37 0 0 0 .402-.367v-2.137a.37.37 0 0 0-.342-.369M100.656 12.084c-1.504 0-2.627.595-3.346 1.46v-.866a.37.37 0 0 0-.37-.37h-2.18a.37.37 0 0 0-.37.37v15.083c0 .204.166.37.37.37h2.18a.37.37 0 0 0 .37-.37v-4.874c.719.875 1.842 1.47 3.346 1.47 3.279 0 5.166-2.784 5.166-6.142 0-3.346-1.887-6.13-5.166-6.13m-.64 9.747c-1.583 0-2.773-1.18-2.773-3.268v-.673c0-2.123 1.19-3.28 2.773-3.28 1.864 0 2.864 1.472 2.864 3.605 0 2.145-1 3.616-2.864 3.616M117.792 21.906c-.455-.02-.64-.253-.64-.782v-4.952c0-2.73-1.752-4.088-4.66-4.088-2.515 0-4.216 1.358-4.894 3.136a.37.37 0 0 0 .27.497l2.028.42a.37.37 0 0 0 .421-.233c.326-.9.956-1.35 2.062-1.35 1.37 0 1.92.663 1.92 1.73v.19l-3.099.618c-2.324.45-4.11 1.438-4.11 3.74 0 2.1 1.719 3.48 3.998 3.48 1.538 0 2.751-.482 3.504-1.313.433.92 1.456 1.323 3.226 1.15a.37.37 0 0 0 .333-.368v-1.506c0-.2-.159-.36-.359-.37m-3.493-1.973c0 1.381-1.313 2.111-2.694 2.111-.989 0-1.629-.494-1.629-1.358 0-1 .809-1.348 1.898-1.572l2.425-.506zM129.487 12.309h-2.178a.37.37 0 0 0-.35.25l-2.632 7.767-2.699-7.77a.37.37 0 0 0-.349-.247h-2.247a.37.37 0 0 0-.345.499l4.079 10.853-.415 1.022c-.36.898-.798 1.134-1.662 1.134-.196 0-.345-.007-.501-.019a.37.37 0 0 0-.398.368v1.667c0 .19.145.35.334.367.221.021.436.032.834.032 2.527 0 3.582-1.292 4.301-3.234l4.574-12.19a.37.37 0 0 0-.346-.5"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconAppleSignIn = {
  name: 'apple-sign-in',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
  <path fill="#000" d="M16.95 7.083c-.106.083-1.984 1.14-1.984 3.493 0 2.721 2.39 3.684 2.46 3.708-.01.058-.379 1.318-1.259 2.601-.785 1.13-1.604 2.257-2.851 2.257s-1.568-.724-3.007-.724c-1.403 0-1.901.748-3.042.748s-1.936-1.045-2.851-2.328C3.356 15.33 2.5 12.989 2.5 10.767c0-3.564 2.318-5.455 4.598-5.455 1.212 0 2.223.796 2.984.796.724 0 1.853-.843 3.232-.843.523 0 2.4.047 3.636 1.818m-4.29-3.327c.57-.677.973-1.616.973-2.554 0-.13-.01-.263-.035-.369-.928.035-2.031.618-2.697 1.39-.522.594-1.01 1.533-1.01 2.484 0 .143.024.286.035.332.058.011.154.024.25.024.832 0 1.879-.557 2.483-1.307"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconDsgStorePickup = {
  name: 'dsg-store-pickup',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="140" height="20" fill="none" viewBox="0 0 140 20">
  <path fill="#006554" d="M1.823 4.484v9.423h2.195l.613-.613V5.098l-.613-.614zM0 15.391V3h4.961l1.485 1.484v9.423L4.96 15.392zM8.56 3h1.824v12.392H8.56zm8.577 8.043h1.816v2.864l-1.493 1.485h-3.469l-1.484-1.485V4.484L13.99 3h3.469l1.492 1.484V7.13h-1.815V5.098l-.613-.614h-1.589l-.613.614v8.196l.613.613h1.59l.612-.613zm5.624 4.349h-1.823V3h1.823v5.3h.081L25.504 3h1.88l-2.96 5.865 3.04 6.527H25.52l-2.678-5.6h-.08zM30.225 3v2.098l-.694 1.54h-.71l.492-1.54h-.492V3zm1.671 8.342h1.815v1.952l.613.613h1.638l.605-.613v-2.3l-.363-.443-3.122-1.242-1.154-1.404v-3.42L33.413 3h3.42l1.485 1.484V6.93h-1.815V5.098l-.614-.614h-1.565l-.613.614v2.194l.363.435 3.122 1.219 1.154 1.403v3.558l-1.485 1.485H33.38l-1.484-1.485zm11.297 0h1.815v1.952l.613.613h1.637l.606-.613v-2.3l-.363-.443-3.122-1.242-1.154-1.404v-3.42L44.709 3h3.42l1.485 1.484V6.93H47.8V5.098l-.613-.614H45.62l-.613.614v2.194l.363.435 3.122 1.219 1.154 1.403v3.558l-1.485 1.485h-3.485l-1.484-1.485zm10.069 6.365h-1.735V6.219h1.59l.064 1.323.976-1.323H56.4l1.242 1.242v6.688L56.4 15.392h-2.162l-.976-1.307zm1.024-3.639h1.17l.452-.443v-5.64l-.452-.443h-1.17l-1.024 1.355v3.816zm9.4-.443v-5.64l-.444-.443h-1.67l-.443.444v5.639l.443.443h1.67zm-4.292.524V7.461l1.234-1.242h3.558L65.42 7.46v6.688l-1.234 1.243h-3.558zm9.634 1.243h-1.735V6.219h1.59l.064 1.323.992-1.323h1.5v1.654h-1.548l-.863 1.024zm4.712-7.85H72.7V6.219h1.04V3.912h1.735v2.307h2.049v1.323h-2.05v6.163l.364.363h1.686v1.324h-2.582l-1.202-1.21zm7.327-1.323v9.173h-1.735V6.219zm0-2.888v1.815h-1.735V3.33zm3.784 12.06h-1.734V6.22h1.59l.064 1.323.992-1.323h2.097l1.235 1.242v7.93H87.36V7.987l-.444-.444h-.96l-1.105 1.29zm6.068-.048h1.735v.678l.363.363h1.83l.445-.444v-2.646l-.969 1.307h-2.17l-1.234-1.243V7.461l1.234-1.242h2.251l.976 1.323.065-1.323h1.581v10.245l-1.234 1.243h-3.72l-1.153-1.162zm1.735-2.509.443.444h1.17l1.025-1.356V8.897l-1.025-1.355h-1.17l-.443.444zm15.975-5.704h-1.815V5.098l-.613-.614h-1.654l-.613.614v8.196l.613.613h1.654l.613-.613V10.47h-1.605V8.978h3.42v4.93l-1.484 1.484h-3.542l-1.484-1.485V4.484L103.603 3h3.542l1.484 1.484zm6.181 6.495v-5.64l-.444-.443h-1.67l-.443.444v5.639l.443.443h1.67zm-4.292.524V7.461l1.235-1.242h3.557l1.234 1.242v6.688l-1.234 1.243h-3.557zm12.062-.524v-5.64l-.444-.443h-1.67l-.443.444v5.639l.443.443h1.67zm-4.292.524V7.461l1.234-1.242h3.558l1.235 1.242v6.688l-1.235 1.243h-3.558zM130.43 3h1.735v12.392h-1.581l-.064-1.324-.977 1.324h-2.251l-1.234-1.243V7.461l1.234-1.242h2.171l.967 1.307zm-2.194 11.068h1.17l1.024-1.355V8.897l-1.024-1.355h-1.17l-.443.444v5.639zm5.785-1.621h1.735v1.178l.444.443h1.621l.444-.443v-1.436l-.298-.331-2.977-.88-.936-1.072V7.46l1.235-1.242h3.452l1.242 1.242v1.654h-1.734v-1.13l-.444-.443h-1.573l-.444.444v1.371l.299.33 2.969.88.944 1.073v2.51l-1.243 1.242h-3.501l-1.235-1.243z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconFlagFilled = {
  name: 'flag-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="var(--hmf-icon-color, #161313)" d="M12.557 3a1 1 0 0 1 .936.648l.264.704a1 1 0 0 0 .936.648H19a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-5.557a1 1 0 0 1-.936-.648l-.264-.704a1 1 0 0 0-.936-.648H6V19a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconGgStorePickup = {
  name: 'gg-store-pickup',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="140" height="20" fill="none" viewBox="0 0 140 20">
  <path fill="#001F39" d="M0 10.399v-.035C0 6.865 2.853 4 6.757 4c2.324 0 3.718.598 5.062 1.687l-1.786 2.058c-.993-.792-1.877-1.249-3.369-1.249-2.062 0-3.701 1.74-3.701 3.833v.035c0 2.249 1.626 3.902 3.903 3.902 1.03 0 1.951-.245 2.673-.74v-1.76H6.684v-2.33h5.597v5.341a8.6 8.6 0 0 1-5.505 1.95C2.762 16.727 0 14.038 0 10.404M15.023 10.399v-.035C15.023 6.865 17.913 4 21.89 4s6.83 2.83 6.83 6.329v.035c0 3.498-2.89 6.363-6.867 6.363s-6.83-2.83-6.83-6.323zm10.732.005v-.034c0-2.108-1.62-3.868-3.902-3.868s-3.867 1.723-3.867 3.832v.036c0 2.108 1.621 3.867 3.904 3.867s3.865-1.723 3.865-3.833M31.83 4.21h2.836v9.845h6.425v2.46H31.83zM44.209 4.21h9.811v2.462h-6.977v2.62h5.782v2.46h-5.782v4.763H44.21zM61.396 10.399v-.035C61.396 6.99 63.992 4 67.858 4c2.171 0 3.515.598 4.805 1.635l-.939 1.055c-.995-.825-2.1-1.405-3.922-1.405-2.853 0-4.897 2.303-4.897 5.045v.035c0 2.936 1.97 5.115 5.1 5.115a6.25 6.25 0 0 0 3.717-1.23v-3.06h-3.92V9.942h5.32v4.905a8.02 8.02 0 0 1-5.172 1.886c-4.05 0-6.555-2.813-6.555-6.323M80.637 4.123h1.362l5.873 12.394h-1.565l-1.51-3.253h-7.014l-1.528 3.253h-1.49zm3.601 7.892L81.3 5.74l-2.945 6.274zM90.165 4.21h1.454v11.023h7.235l-.616 1.282h-8.073zM105.876 4h1.36l5.873 12.393h-1.566l-1.51-3.252h-7.013l-1.529 3.252H100zm3.588 7.892-2.928-6.277-2.946 6.277zM119.365 10.24l-4.77-6.03h1.712l3.959 5.028 3.921-5.027h1.694l-4.767 6.011 4.951 6.295h-1.73l-4.126-5.29-4.124 5.29h-1.674zM133.169 11.647l-5.357-7.436h1.768l4.344 6.153 4.381-6.153H140l-5.358 7.419v4.887h-1.473z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconGggStorePickup = {
  name: 'ggg-store-pickup',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="140" height="20" fill="none" viewBox="0 0 140 20">
  <path fill="#00A537" d="M5.556 2 3.138 3.889 0 15.343l1.384 1.889h5.008l2.418-1.89 1.747-6.376H6.04l-.735 2.68h1.33l-.797 2.905H3.57l2.704-9.87H8.38l-.757 2.762h3.353l.973-3.554L10.564 2zM16.27 4.68h2.125l-2.703 9.87h-2.126zM15.551 2l-2.418 1.889-3.138 11.454 1.384 1.889h5.029l2.418-1.89L21.964 3.89 20.582 2zM23.79 2l-4.172 15.232h3.352L27.142 2zM34.562 2l-2.208 8.062h-.082L31.905 2h-3.353L24.38 17.232h2.862l2.209-8.063h.081l.53 8.063h3.19L37.424 2zM40.614 2l-2.419 1.889-3.137 11.454 1.383 1.889h5.008l2.419-1.89 1.747-6.376h-4.518l-.734 2.68h1.329l-.796 2.905h-2.27l2.705-9.87h2.105l-.757 2.762h3.353l.974-3.554L45.622 2zM52.561 2l-2.418 1.889-3.138 11.454 1.384 1.888h5.008l2.419-1.888 1.747-6.377h-4.518l-.734 2.68h1.329l-.796 2.905h-2.27l2.705-9.87h2.105l-.757 2.762h3.353l.974-3.554L57.57 2zM63.275 4.68H65.4l-2.703 9.87H60.57zM62.558 2l-2.42 1.889-3.136 11.454 1.383 1.888h5.029l2.418-1.888L68.97 3.889 67.586 2zM70.795 2l-4.172 15.231h3.352L74.147 2zM81.568 2l-2.209 8.062h-.082L78.91 2h-3.352l-4.172 15.231h2.861l2.209-8.062h.082l.53 8.062h3.19L84.43 2zM87.618 2 85.2 3.889l-3.138 11.454 1.384 1.888h5.008l2.419-1.888 1.746-6.377h-4.517l-.734 2.68h1.328l-.795 2.905h-2.27l2.704-9.87h2.106l-.757 2.762h3.353l.973-3.554L92.628 2zM99.567 2 97.148 3.89 94.01 15.343l1.384 1.888h5.009l2.418-1.888 1.747-6.377h-4.518l-.734 2.68h1.329l-.796 2.905H97.58l2.704-9.87h2.105l-.756 2.762h3.352l.974-3.554L104.575 2zM110.28 4.68h2.126l-2.704 9.87h-2.126zM109.563 2l-2.419 1.889-3.137 11.454 1.383 1.888h5.029l2.418-1.888 3.138-11.454L114.591 2zM123.79 2l-2.209 8.063h-.081L121.132 2h-3.352l-4.172 15.231h2.862l2.208-8.062h.082l.531 8.062h3.189l4.172-15.23zM128.042 2l-4.172 15.231h7.318l.779-2.843h-3.966l.945-3.452h3.659l.78-2.843h-3.66l.89-3.25h3.966L135.36 2zM133.325 14.429l-.768 2.802h3.271l.768-2.802zM136.73 2l-1.497 5.463-1.134 5.93h2.29l2.115-5.93L140 2z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconGiftBoxIcon = {
  name: 'gift-box-icon',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="var(--hmf-icon-color, #141414)" viewBox="0 -960 960 960">
  <path d="M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440zm400-760q-17 0-28.5 11.5T520-800t11.5 28.5T560-760t28.5-11.5T600-800t-11.5-28.5T560-840m-200 40q0 17 11.5 28.5T400-760t28.5-11.5T440-800t-11.5-28.5T400-840t-28.5 11.5T360-800M160-680v80h280v-80zm280 520v-360H240v360zm80 0h200v-360H520zm280-440v-80H520v80z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconGoogleSignIn = {
  name: 'google-sign-in',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
  <path fill="#4285F4" d="M18.8 10.208q-.002-.975-.167-1.875H10v3.55h4.933a4.23 4.23 0 0 1-1.841 2.758v2.309h2.975C17.8 15.35 18.8 13 18.8 10.208"/>
  <path fill="#34A853" d="M10 19.167c2.475 0 4.55-.817 6.066-2.217l-2.975-2.308c-.816.55-1.858.883-3.091.883-2.384 0-4.409-1.608-5.134-3.775h-3.05v2.367c1.509 2.991 4.6 5.05 8.184 5.05"/>
  <path fill="#FBBC05" d="M4.866 11.742A5.5 5.5 0 0 1 4.575 10c0-.608.108-1.192.291-1.742V5.892h-3.05A9.05 9.05 0 0 0 .833 10c0 1.483.358 2.875.983 4.108l2.375-1.85z"/>
  <path fill="#EA4335" d="M10 4.483c1.35 0 2.55.467 3.508 1.367l2.625-2.625C14.541 1.74 12.475.833 10 .833c-3.584 0-6.675 2.058-8.184 5.058l3.05 2.367C5.591 6.091 7.616 4.483 10 4.483"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconMoneyAffirm = {
  name: 'money-affirm',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="75" height="55" viewBox="0 0 74 55">
  <defs>
    <clipPath id="money-affirm_svg__a">
      <path d="M0 0h73.926v54H0Zm0 0"/>
    </clipPath>
    <clipPath id="money-affirm_svg__b">
      <path d="M21 19h31v35.64H21Zm0 0"/>
    </clipPath>
  </defs>
  <g clip-path="url(#money-affirm_svg__a)">
    <path d="M12.063 53.68a29.95 29.95 0 0 1-4.856-16.395c0-16.527 13.332-29.969 29.723-29.969 16.386 0 29.722 13.442 29.722 29.97a30 30 0 0 1-4.859 16.394h8.32a37.3 37.3 0 0 0 3.778-16.395C73.89 16.735 57.309.02 36.934.02 16.554.02-.027 16.738-.027 37.285A37.3 37.3 0 0 0 3.75 53.68Zm0 0" stroke="none" fill-rule="nonzero" fill="#4a4af4" fill-opacity="1"/>
  </g>
  <g clip-path="url(#money-affirm_svg__b)">
    <path d="M37.426 19.578c-5.41 0-11.64 2.57-15.024 5.293l3.086 6.55c2.711-2.503 7.098-4.636 11.051-4.636 3.758 0 5.832 1.266 5.832 3.82 0 1.715-1.379 2.684-3.976 2.922-9.75.907-17.329 3.977-17.329 11.524 0 5.984 4.282 9.597 11.32 9.597 4.712 0 8.41-2.636 10.407-6.12v5.148h8.777v-21.57c.004-8.907-6.136-12.528-14.144-12.528m-2.563 28.156c-2.843 0-4.406-1.226-4.406-3.242 0-4.207 5.098-5.219 11.73-5.219 0 4.399-2.921 8.461-7.324 8.461m0 0" stroke="none" fill-rule="nonzero" fill="#000" fill-opacity="1"/>
  </g>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconMoneyCreditcardScorerewards = {
  name: 'money-creditcard-scorerewards',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="37" height="24" fill="none" viewBox="0 0 37 24">
  <path fill="#191F1C" d="M0 2a2 2 0 0 1 2-2h33a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"/>
  <path fill="#fff" d="M3 19h10v1H3zM3 3h5v1H3z"/>
  <path fill="#F9F9F9" d="M13 3h21v8H13z"/>
  <path fill="#191F1C" d="M16.21 8.945v-3.89h-.84v3.89zM14 10V4h2.806l.775.742v4.516l-.775.742zM18.12 4h1.37v6h-1.37zM23.586 6.145h-1.37v-1.09h-.82v3.89h.82V7.742h1.37v1.516l-.78.742h-2.002l-.78-.742V4.742l.78-.742h2.003l.779.742zM25.438 10h-1.371V4h1.37v2.434h.041L26.302 4h1.4l-1.02 2.84 1.06 3.16h-1.448l-.816-2.512h-.04zM29.031 4v1.152l-.542.778h-.461l.334-.778h-.334V4zM29.439 7.969h1.37v.976h.853V7.816l-1.538-.488-.685-.703V4.742l.78-.742h1.994l.779.742v1.25h-1.37v-.937h-.845v1.09l1.538.48.685.703v1.93l-.78.742h-2.002l-.779-.742z"/>
  <circle cx="3.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="5.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="7.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="12.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="14.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="16.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="20.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="22.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="24.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="29.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="31.75" cy="14.75" r=".75" fill="#F9F9F9"/>
  <circle cx="33.75" cy="14.75" r=".75" fill="#F9F9F9"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconPlStorePickup = {
  name: 'pl-store-pickup',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="9" fill="none" viewBox="0 0 100 9">
  <path fill="var(--hmf-icon-color, #002A19)" d="M94.807 3.073h1.591c2.455 0 3.602.863 3.602 2.47 0 2.124-1.41 2.653-4.466 2.653-3.382 0-4.465-1.42-4.465-2.85h2.192c.091.724.75.772 2.517.772 1.46 0 2.083-.032 2.083-.636 0-.543-.56-.596-1.177-.596h-1.789c-2.783 0-3.69-.998-3.69-2.434C91.205.845 92.157 0 95.537 0c2.957 0 4.265 1.15 4.265 2.564h-2.104c-.123-.692-.816-.706-2.097-.706-1.28 0-2.26.006-2.26.661 0 .398.316.554 1.466.554"/>
  <path fill="var(--hmf-icon-color, #002A19)" fill-rule="evenodd" d="M64.395.112 60.04 8.113h2.388l.618-1.192h4.466l.617 1.192h2.388l-4.332-8zm-.442 5.02 1.15-2.233h.332l1.15 2.233zM86.453.112h-4.95v8.001h4.886c2.872 0 4.089-1.59 4.089-4s-1.33-4-4.025-4m.11 5.726h-2.984V2.39h2.984c1.305 0 1.789.684 1.789 1.724s-.573 1.723-1.79 1.723M26.479 5.661a2.08 2.08 0 0 0-1.193-1.923c.53-.31.861-.772.861-1.524 0-1.26-1.15-2.078-2.695-2.078h-5.453v7.956h5.429c2.077 0 3.05-.861 3.05-2.43m-6.405-3.757 3.174-.021c.554 0 .84.222.84.596 0 .465-.243.642-.818.642h-3.196zm0 2.805h3.418c.575 0 .95.222.95.73 0 .441-.332.642-.907.642h-3.46z" clip-rule="evenodd"/>
  <path fill="var(--hmf-icon-color, #002A19)" d="M16.93 4.27c0 2.65-1.482 3.956-4.135 3.956-2.628 0-4.134-1.305-4.136-3.955V.136h2.077V3.96c0 1.436.6 1.923 2.08 1.923 1.482 0 2.036-.487 2.036-1.923V.136h2.078z"/>
  <path fill="var(--hmf-icon-color, #002A19)" fill-rule="evenodd" d="M2.078 6.102H4.62c1.548 0 3.27-.398 3.27-3.094C7.891.556 5.97.136 4.533.136H0v7.956h2.078zm0-3.8h2.698c.618 0 1.104.156 1.104.861 0 .706-.42.862-1.037.862H2.078z" clip-rule="evenodd"/>
  <path fill="var(--hmf-icon-color, #002A19)" d="M29.46 5.883h4.6v2.209h-6.677V.112h2.077zM36.977.112H34.9v7.98h2.077zM77.974 5.594h.155V.136h2.077v7.977h-2.211c-2.032-1.171-3.623-2.829-4.752-4.42h-.155v4.423H71.01V.136h2.388c.928 1.923 3.027 4.354 4.576 5.458M55.091.112h-2.077v8.001h6.674v-2.23h-4.597zM46.778 5.196c-.377 2.856-3.166 2.997-4.471 2.997-1.458 0-4.624-.291-4.624-4.102 0-3.733 3.166-4.086 4.624-4.086 2.497 0 4.238.899 4.481 2.998h-2.035c-.206-.64-1.232-.912-2.4-.912-1.375 0-2.453.575-2.453 1.992s1.078 2.025 2.452 2.025c1.12 0 2.102-.155 2.401-.912z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecard = {
  name: 'scorecard',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="133" height="24" fill="none" viewBox="0 0 1011 170">
  <path fill="#006554" d="M.677 112.448h37.187v27.669h23.132v-31.985L19.27 94.297.677 74.375V21.029L21.817 0h54.12l21.14 21.029v35.416H59.888V29.883h-22.91v30.879l41.725 13.613 18.594 19.922v54.674L76.158 170H21.817L.676 148.971zM211.428 60.762h-37.187v-30.88h-22.247v110.235h22.247v-34.088h37.187v42.942L190.289 170h-54.343l-21.139-21.029V21.029L135.946 0h54.343l21.139 21.029zM289.699 140.117V29.883h-23.574v110.234zM250.077 170l-21.14-21.029V21.029L250.077 0h55.781l21.028 21.029V148.97L305.858 170zM384.129 170h-37.188V0h75.925l21.028 21.029v51.686l-15.827 15.937 15.827 15.827V170h-37.187v-67.292h-22.578zm22.578-95.404V29.883h-22.578v44.713zM463.949 170V0h81.126v31.764h-43.939v36.192h40.508V99.72h-40.508v38.516h43.939V170zM659.537 60.762H622.35v-30.88h-22.246v110.235h22.246v-34.088h37.187v42.942L638.398 170h-54.342l-21.14-21.029V21.029L584.056 0h54.342l21.139 21.029zM743.121 170l-5.202-36.081h-27.227L705.491 170h-34.532L699.625 0h53.014l28.555 170zM723.863 44.603l-8.411 56.667h17.708l-8.412-56.667zM834.009 170h-37.188V0h75.925l21.028 21.029v51.686l-15.826 15.937 15.826 15.827V170h-37.187v-67.292h-22.578zm22.578-95.404V29.883h-22.578v44.713zM973.816 140.117V29.883h-22.799v110.234zM913.829 170V0h76.146L1011 21.029V148.97L989.975 170z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardBanner = {
  name: 'scorecard-banner',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="61" height="18" fill="none" viewBox="0 0 61 18">
  <g clip-path="url(#scorecard-banner_svg__a)">
    <path fill="#006554" d="M0 0h61l-5 18H0z"/>
    <path fill="#fff" d="M3.299 10.453h1.969v1.465h1.224v-1.693l-2.209-.733L3.3 8.437V5.614L4.418 4.5h2.865l1.12 1.113v1.875h-1.97V6.082H5.222v1.635l2.209.72.984 1.055v2.895L7.294 13.5H4.419l-1.12-1.113zm10.857-2.736h-1.969V6.082H11.01v5.836h1.178v-1.805h1.968v2.274L13.037 13.5H10.16l-1.119-1.113V5.613l1.12-1.113h2.876l1.12 1.113zM18 11.918V6.082h-1.248v5.836zM15.902 13.5l-1.119-1.113V5.613l1.12-1.113h2.952l1.114 1.113v6.774L18.855 13.5zm6.797 0H20.73v-9h4.02l1.113 1.113V8.35l-.838.843.838.838V13.5h-1.968V9.938h-1.196zm1.195-5.05V6.081H22.7v2.367zm2.731 5.05v-9h4.295v1.682h-2.326v1.916h2.144v1.681h-2.144v2.04h2.326V13.5zM36.68 7.717h-1.97V6.082h-1.177v5.836h1.178v-1.805h1.969v2.274L35.56 13.5h-2.876l-1.12-1.113V5.613l1.12-1.113h2.877l1.119 1.113zm4.125 5.783-.276-1.91h-1.441l-.276 1.91h-1.828l1.518-9h2.807l1.511 9zm-1.02-6.639-.445 3h.937l-.445-3zm5.531 6.639h-1.968v-9h4.02l1.112 1.113V8.35l-.837.843.837.838V13.5h-1.968V9.938h-1.196zm1.196-5.05V6.081h-1.196v2.367zm5.906 3.468V6.082h-1.207v5.836zM49.242 13.5v-9h4.031l1.114 1.113v6.774L53.273 13.5z"/>
  </g>
  <defs>
    <clipPath id="scorecard-banner_svg__a">
      <path fill="#fff" d="M0 0h61v18H0z"/>
    </clipPath>
  </defs>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardDark = {
  name: 'scorecard-dark',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="17" fill="none" viewBox="0 0 100 17">
  <path fill="#161313" d="M.06 11.245h3.848v2.767h2.395v-3.199L1.983 9.43.06 7.438V2.103L2.247 0H7.85l2.188 2.103v3.542H6.188V2.988H3.817v3.088l4.319 1.362L10.06 9.43v5.467L7.872 17H2.247L.06 14.897zM21.287 6.076h-3.85V2.988h-2.302v11.024h2.303v-3.41h3.849v4.295L19.099 17h-5.625l-2.188-2.103V2.103L13.474 0h5.625l2.188 2.103zM28.801 14.012V2.988h-2.44v11.024zM24.701 17l-2.189-2.103V2.103L24.7 0h5.774l2.177 2.103v12.794L30.474 17zM37.989 17h-3.85V0H42l2.176 2.103V7.27l-1.638 1.594 1.638 1.583V17h-3.85v-6.73H37.99zm2.337-9.54V2.988h-2.337V7.46zM45.664 17V0h8.397v3.176h-4.548v3.62h4.193v3.176h-4.193v3.852h4.548V17zM65.322 6.076h-3.85V2.988H59.17v11.024h2.303v-3.41h3.849v4.295L63.134 17h-5.625l-2.188-2.103V2.103L57.51 0h5.625l2.188 2.103zM73.387 17l-.539-3.608H70.03L69.492 17h-3.574l2.967-17h5.487l2.955 17zM71.393 4.46l-.87 5.667h1.833l-.871-5.667zM82.207 17h-3.849V0h7.859l2.176 2.103V7.27l-1.638 1.594 1.638 1.583V17h-3.849v-6.73h-2.337zm2.337-9.54V2.988h-2.337V7.46zM96.092 14.012V2.988h-2.36v11.024zM89.882 17V0h7.882l2.177 2.103v12.794L97.764 17z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardGold = {
  name: 'scorecard-gold',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="116" height="14" fill="none" viewBox="0 0 116 14">
  <path fill="#141414" d="M0 9.26h3.17v2.28h1.972V8.904l-3.557-1.14L0 6.126V1.732L1.802 0h4.613l1.802 1.732v2.916h-3.17V2.461H3.094v2.543l3.557 1.121 1.585 1.64v4.503L6.434 14H1.802L0 12.268zM17.481 5.004h-3.17V2.46h-1.896v9.078h1.896V8.732h3.17v3.536L15.68 14h-4.632l-1.802-1.732V1.732L11.047 0h4.632l1.802 1.732zM23.67 11.54V2.46h-2.01v9.08zM20.293 14l-1.802-1.732V1.732L20.293 0h4.754l1.793 1.732v10.536L25.047 14zM31.236 14h-3.17V0h6.472l1.792 1.732v4.256l-1.349 1.313 1.35 1.303V14h-3.17V8.458h-1.925zm1.925-7.857V2.461h-1.925v3.682zM37.557 14V0h6.915v2.616h-3.745v2.98h3.453v2.616h-3.453v3.172h3.745V14zM53.746 5.004h-3.17V2.46h-1.897v9.078h1.897V8.732h3.17v3.536L51.944 14h-4.632l-1.802-1.732V1.732L47.312 0h4.632l1.802 1.732zM60.387 14l-.443-2.971h-2.321L57.18 14h-2.944L56.68 0h4.519l2.434 14zM58.746 3.673l-.717 4.667h1.51l-.718-4.667zM67.651 14h-3.17V0h6.472l1.793 1.732v4.256l-1.35 1.313 1.35 1.303V14h-3.17V8.458H67.65zm1.925-7.857V2.461H67.65v3.682zM79.085 11.54V2.46h-1.943v9.08zM73.972 14V0h6.49l1.793 1.732v10.536L80.463 14z"/>
  <path fill="#C5AD6A" d="M110.161.93v12.14h3.409l1.048-1.048V1.978L113.57.93zM109.113 14V0h4.931l1.623 1.622v10.756L114.044 14zM101.803 14V0h1.048v13.07h4.403V14zM93.819 1.978v10.044l1.048 1.048h2.598l1.039-1.048V1.978L97.464.93h-2.597zM94.402 14l-1.622-1.622V1.622L94.402 0h3.528l1.622 1.622v10.756L97.93 14zM90.62 4.33H89.57V1.977L88.534.93H85.99L84.94 1.978v10.044l1.049 1.048h2.543l1.038-1.048V8.066h-2.588v-.938h3.637v5.25L88.997 14h-3.472l-1.623-1.622V1.622L85.525 0h3.472l1.623 1.622z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardGoldBanner = {
  name: 'scorecard-gold-banner',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="85" height="18" fill="none" viewBox="0 0 85 18">
  <g clip-path="url(#scorecard-gold-banner_svg__a)">
    <path fill="#C5AD6A" d="M0 0h85l-5.986 18H0z"/>
    <path fill="#161313" d="M3.299 9.953h1.969v1.465h1.224V9.725l-2.209-.733L3.3 7.937V5.114L4.418 4h2.865l1.12 1.113v1.875h-1.97V5.582H5.222v1.635l2.209.72.984 1.055v2.895L7.294 13H4.419l-1.12-1.113zm10.857-2.736h-1.969V5.582H11.01v5.836h1.178V9.613h1.968v2.274L13.037 13H10.16l-1.119-1.113V5.113L10.161 4h2.876l1.12 1.113zM18 11.418V5.582h-1.248v5.836zM15.902 13l-1.119-1.113V5.113L15.903 4h2.952l1.114 1.113v6.774L18.855 13zm6.797 0H20.73V4h4.02l1.113 1.113V7.85l-.838.843.838.838V13h-1.968V9.438h-1.196zm1.195-5.05V5.581H22.7v2.367zM26.626 13V4h4.295v1.682h-2.326v1.916h2.144v1.681h-2.144v2.04h2.326V13zM36.68 7.217h-1.97V5.582h-1.177v5.836h1.178V9.613h1.969v2.274L35.56 13h-2.876l-1.12-1.113V5.113L32.685 4h2.877l1.119 1.113zM40.805 13l-.276-1.91h-1.441L38.812 13h-1.828l1.518-9h2.807l1.511 9zm-1.02-6.639-.445 3h.937l-.445-3zM45.316 13h-1.968V4h4.02l1.112 1.113V7.85l-.837.843.837.838V13h-1.968V9.438h-1.196zm1.196-5.05V5.581h-1.196v2.367zm5.906 3.468V5.582h-1.207v5.836zM49.242 13V4h4.031l1.114 1.113v6.774L53.273 13zm12.364-6.217h-.674V5.271l-.668-.673h-1.635l-.674.673v6.458l.674.673h1.635l.668-.673V9.186h-1.664v-.604h2.337v3.375L60.564 13H58.33l-1.043-1.043V5.043L58.33 4h2.233l1.042 1.043zm2.056-1.512v6.458l.674.673h1.67l.668-.673V5.27l-.668-.673h-1.67zM64.037 13l-1.043-1.043V5.043L64.037 4h2.268l1.043 1.043v6.914L66.305 13zm4.758 0V4h.674v8.402h2.83V13zm5.373-8.402v7.804h2.191l.674-.673V5.27l-.674-.673zM73.494 13V4h3.17l1.043 1.043v6.914L76.664 13z"/>
  </g>
  <defs>
    <clipPath id="scorecard-gold-banner_svg__a">
      <path fill="#fff" d="M0 0h85v18H0z"/>
    </clipPath>
  </defs>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardGoldLight = {
  name: 'scorecard-gold-light',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="141" height="17" fill="none" viewBox="0 0 141 17">
  <path fill="#fff" d="M.226 11.245h3.85v2.767h2.393v-3.199L2.151 9.43.226 7.438V2.103L2.414 0h5.602l2.188 2.103v3.542h-3.85V2.988h-2.37v3.088l4.318 1.362 1.925 1.992v5.467L8.039 17H2.414L.226 14.897zM21.453 6.076h-3.849V2.988h-2.302v11.024h2.302v-3.41h3.85v4.295L19.264 17h-5.624l-2.188-2.103V2.103L13.64 0h5.624l2.188 2.103zM28.968 14.012V2.988h-2.44v11.024zM24.868 17l-2.189-2.103V2.103L24.867 0h5.774l2.176 2.103v12.794L30.641 17zM38.156 17h-3.85V0h7.86l2.176 2.103V7.27l-1.639 1.594 1.639 1.583V17h-3.85v-6.73h-2.336zm2.337-9.54V2.988h-2.337V7.46zM45.83 17V0h8.398v3.176H49.68v3.62h4.193v3.176H49.68v3.852h4.548V17zM65.489 6.076h-3.85V2.988h-2.302v11.024h2.303v-3.41h3.849v4.295L63.3 17h-5.625l-2.188-2.103V2.103L57.676 0H63.3l2.188 2.103zM73.553 17l-.538-3.608h-2.818L69.659 17h-3.575l2.967-17h5.488l2.955 17zM71.56 4.46l-.87 5.667h1.832l-.87-5.667zM82.374 17h-3.849V0h7.859l2.176 2.103V7.27l-1.638 1.594 1.638 1.583V17h-3.849v-6.73h-2.337zm2.337-9.54V2.988h-2.337V7.46zM96.258 14.012V2.988h-2.36v11.024zM90.05 17V0h7.882l2.176 2.103v12.794L97.931 17zM133.994 1.129V15.87h4.139l1.273-1.273V2.402l-1.273-1.273zM132.721 17V0h5.987l1.97 1.97v13.06l-1.97 1.97zM123.844 17V0h1.273v15.871h5.346V17zM114.149 2.402v12.196l1.273 1.273h3.154l1.262-1.273V2.402l-1.262-1.273h-3.154zM114.857 17l-1.97-1.97V1.97l1.97-1.97h4.284l1.97 1.97v13.06l-1.97 1.97zM110.264 5.257h-1.272V2.402l-1.262-1.273h-3.088l-1.273 1.273v12.196l1.273 1.273h3.088l1.262-1.273V9.795h-3.144v-1.14h4.416v6.375l-1.97 1.97h-4.216l-1.971-1.97V1.97L104.078 0h4.216l1.97 1.97z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardLight = {
  name: 'scorecard-light',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="101" height="17" fill="none" viewBox="0 0 101 17">
  <path fill="#fff" d="M.285 11.245h3.85v2.767h2.394v-3.199L2.21 9.43.285 7.438V2.103L2.474 0h5.601l2.188 2.103v3.542H6.414V2.988H4.043v3.088l4.319 1.362 1.924 1.992v5.467L8.098 17H2.474L.285 14.897zM21.513 6.076h-3.85V2.988h-2.302v11.024h2.303v-3.41h3.849v4.295L19.325 17H13.7l-2.188-2.103V2.103L13.7 0h5.625l2.188 2.103zM29.028 14.012V2.988h-2.44v11.024zM24.927 17l-2.189-2.103V2.103L24.928 0H30.7l2.177 2.103v12.794L30.7 17zM38.215 17h-3.85V0h7.86L44.4 2.103V7.27l-1.638 1.594 1.638 1.583V17h-3.85v-6.73h-2.336zm2.337-9.54V2.988h-2.337V7.46zM45.89 17V0h8.397v3.176H49.74v3.62h4.193v3.176h-4.193v3.852h4.548V17zM65.548 6.076h-3.85V2.988h-2.302v11.024H61.7v-3.41h3.849v4.295L63.36 17h-5.625l-2.188-2.103V2.103L57.735 0h5.625l2.188 2.103zM73.613 17l-.539-3.608h-2.818L69.718 17h-3.574L69.11 0h5.487l2.956 17zM71.62 4.46l-.871 5.667h1.833l-.87-5.667zM82.434 17h-3.85V0h7.859l2.177 2.103V7.27L86.98 8.865l1.639 1.583V17h-3.85v-6.73h-2.337zm2.337-9.54V2.988h-2.338V7.46zM96.318 14.012V2.988h-2.36v11.024zM90.108 17V0h7.882l2.177 2.103v12.794L97.99 17z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardLogoGoldLightHorizontalNone = {
  name: 'scorecard-logo-gold-light-horizontal-none',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="371" height="100" fill="none" viewBox="0 0 371 100">
  <path fill="#fff" d="M5.523 77.14 0 71.619v-9.556h9.733v7.241h6.056v-8.37l-10.92-3.62L0 52.086v-13.95l5.523-5.523h14.185l5.523 5.523v9.258h-9.734V40.45H9.5v8.072l10.925 3.564 4.87 5.225v14.306l-5.523 5.523zm28.433 0-5.523-5.522V38.137l5.523-5.523h14.249l5.523 5.523v10.386h-9.734v-8.072H38.18v28.852h5.815V60.4h9.734v11.218l-5.523 5.523zm22.917-5.522V38.137l5.523-5.523h14.603l5.523 5.523v33.48L77 77.14H62.396zm15.903-31.16H66.6v28.851h6.176zM86.25 77.14V32.62h19.886l5.523 5.523v13.532l-4.153 4.153 4.153 4.154v17.152h-9.733V59.506h-5.935v17.628h-9.734zm15.669-36.682h-5.935V52.15h5.935zm13.475-7.838h21.249v8.313h-11.515v9.5h10.627v8.312h-10.627v10.089h11.515v8.313h-21.249zm29.981 44.52-5.523-5.522V38.137l5.523-5.523h14.248l5.523 5.523v10.386h-9.733v-8.072h-5.815v28.852h5.815V60.4h9.733v11.218l-5.523 5.523zm31.698-9.435-1.363 9.436h-9.023l7.482-44.52h13.887l7.483 44.52h-9.975l-1.363-9.436zm1.243-8.548h4.629l-2.194-14.838h-.234l-2.194 14.838zm19.822 17.983V32.62h19.886l5.523 5.523v13.532l-4.153 4.153 4.153 4.154v17.152h-9.734V59.506h-5.935v17.628h-9.733zm15.675-36.682h-5.935V52.15h5.935zm13.475-7.838h19.943l5.523 5.523v33.48l-5.523 5.524h-19.943zm15.726 7.838h-5.999v28.851h5.999zm25.218 36.644-5.517-5.516v-33.45l5.517-5.516h14.534l5.517 5.517v10.38h-9.728v-8.066h-6.106v28.827h6.582v-8.485h-3.855v-7.83h13.107v18.623l-5.517 5.516zm23.487-5.516v-33.45l5.517-5.516h14.591l5.517 5.517v33.449l-5.517 5.516h-14.591zm15.897-31.135h-6.169v28.827h6.169zm13.462-7.831h9.728v36.182h10.614v8.3h-20.342zm23.608 44.482V32.62h19.93l5.517 5.517v33.449l-5.517 5.516zm15.719-36.65h-5.992v28.826h5.992zM243.883 3.363a9.14 9.14 0 0 1 6.854 1.56 9.12 9.12 0 0 1 3.742 5.954l3.531 20.735h3.266l-3.621-21.28a12.36 12.36 0 0 0-5.053-8.041 12.33 12.33 0 0 0-9.258-2.112l-101.85 17.337a12.35 12.35 0 0 0-8.04 5.054 12.4 12.4 0 0 0-2.201 5.713h3.253a9.14 9.14 0 0 1 1.573-3.856 9.12 9.12 0 0 1 5.954-3.74L243.883 3.35zm9.625 76.511-98.552 16.772a9.14 9.14 0 0 1-6.855-1.56 9.12 9.12 0 0 1-3.741-5.954l-1.325-7.794h-3.266l1.421 8.332a12.36 12.36 0 0 0 5.053 8.04 12.3 12.3 0 0 0 7.147 2.29q1.046.002 2.111-.178l101.85-17.336a12.33 12.33 0 0 0 5.739-2.612z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardLogoLightHorizontalNone = {
  name: 'scorecard-logo-light-horizontal-none',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="268" height="100" fill="none" viewBox="0 0 268 100">
  <path fill="#fff" d="M5.524 77.138 0 71.614v-9.557h9.735v7.242h6.056v-8.371l-10.92-3.621L0 52.08V38.13l5.524-5.524H19.71l5.524 5.524v9.26H15.5v-6.945h-6v8.073l10.927 3.564 4.87 5.226v14.307l-5.523 5.524zm28.436 0-5.523-5.524V38.129l5.524-5.524h14.25l5.523 5.524v10.388H44v-8.073h-5.816v28.855H44v-8.904h9.734v11.219l-5.523 5.524zm22.914-5.518V38.135l5.523-5.523h14.606l5.523 5.523V71.62l-5.523 5.524H62.397zm15.911-31.17h-6.177v28.856h6.177zm13.477 36.688V32.612h19.888l5.524 5.523V51.67l-4.154 4.154 4.154 4.154v17.155h-9.735v-17.63h-5.936v17.63h-9.735zm15.67-36.688h-5.936v11.694h5.936zm13.477-7.838h21.251v8.314h-11.516v9.5h10.629v8.314h-10.629v10.09h11.516v8.314h-21.251zm29.978 44.526-5.524-5.524V38.129l5.524-5.524h14.25l5.524 5.524v10.388h-9.735v-8.073h-5.816v28.855h5.816v-8.904h9.735v11.219l-5.524 5.524zm31.703-9.437-1.364 9.437h-9.024l7.483-44.526h13.889l7.483 44.526h-9.976l-1.363-9.437zm1.249-8.549h4.63l-2.195-14.84h-.234l-2.195 14.84zm19.825 17.986V32.612h19.888l5.523 5.523V51.67l-4.153 4.154 4.153 4.154v17.155h-9.734v-17.63h-5.936v17.63h-9.735zm15.67-36.688h-5.936v11.694h5.936zm13.477-7.838h19.945l5.524 5.523V71.62l-5.524 5.524h-19.945zm15.734 7.838h-6v28.856h6z"/>
  <path fill="#fff" d="m267.531 68.17-9.843-57.837a12.36 12.36 0 0 0-5.054-8.042A12.33 12.33 0 0 0 243.375.18L141.512 17.52a12.36 12.36 0 0 0-8.042 5.054 12.4 12.4 0 0 0-2.2 5.714h3.253a9.15 9.15 0 0 1 1.573-3.856 9.12 9.12 0 0 1 5.955-3.742L243.914 3.35a9.15 9.15 0 0 1 6.855 1.56 9.12 9.12 0 0 1 3.742 5.955l9.842 57.838c.85 4.998-2.524 9.748-7.515 10.604L154.976 96.645a9.14 9.14 0 0 1-6.856-1.56 9.12 9.12 0 0 1-3.742-5.955l-1.325-7.794h-3.266l1.421 8.333a12.36 12.36 0 0 0 5.054 8.042 12.3 12.3 0 0 0 7.147 2.289q1.047.002 2.112-.178l101.863-17.338c6.741-1.148 11.295-7.566 10.147-14.314"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardLogoPlusLightHorizontalNone = {
  name: 'scorecard-logo-plus-light-horizontal-none',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="296" height="100" fill="none" viewBox="0 0 296 100">
  <g fill="#fff" clip-path="url(#scorecard-logo-plus-light-horizontal-none_svg__a)">
    <path d="M5.762 77.136.24 71.613v-9.555h9.732v7.24h6.056v-8.37l-10.919-3.62-4.87-5.224v-13.95l5.523-5.522h14.184l5.523 5.522v9.258h-9.733v-6.943H9.738v8.071l10.925 3.564 4.87 5.224v14.305l-5.523 5.523zm28.432 0-5.523-5.523V38.134l5.523-5.522H48.44l5.523 5.522V48.52H44.23v-8.07h-5.815V69.3h5.815v-8.903h9.733v11.217l-5.523 5.523zm22.908-5.523V38.134l5.523-5.522h14.603l5.522 5.522v33.479l-5.522 5.523H62.625zm15.909-31.158h-6.176v28.85h6.176zm13.474 36.681V32.618h19.884l5.523 5.523v13.53l-4.153 4.154 4.153 4.153v17.151h-9.733V59.502h-5.935V77.13h-9.733zm15.668-36.68h-5.935v11.691h5.935zm13.473-7.838h21.248v8.313h-11.515v9.498h10.627v8.312h-10.627V68.83h11.515v8.313h-21.248zm29.973 44.518-5.523-5.523V38.134l5.523-5.522h14.247l5.523 5.522V48.52h-9.733v-8.07h-5.815V69.3h5.815v-8.903h9.733v11.217l-5.523 5.523zm31.696-9.436-1.363 9.436h-9.023l7.482-44.518h13.886l7.482 44.518h-9.973l-1.364-9.435zm1.25-8.546h4.628l-2.194-14.838h-.234l-2.194 14.838zm19.82 17.982V32.618h19.885l5.522 5.523v13.53l-4.153 4.154 4.153 4.153v17.151h-9.733V59.502h-5.934V77.13h-9.733zm15.674-36.68h-5.934v11.691h5.934zm13.468-7.838h19.941l5.523 5.523v33.478l-5.523 5.523h-19.941zm15.731 7.837h-5.998v28.85h5.998zm26.922 20.747h-13.315V49.535h13.315v-15.09h11.667v15.09h13.315v11.667h-13.315v15.09H270.16z"/>
    <path d="M262.545 76.121a9.15 9.15 0 0 1-5.51 3.19L155.192 96.646a9.14 9.14 0 0 1-6.854-1.56 9.12 9.12 0 0 1-3.741-5.954l-1.325-7.792h-3.266l1.42 8.331a12.36 12.36 0 0 0 5.054 8.04 12.3 12.3 0 0 0 7.146 2.289q1.046.002 2.111-.178l101.844-17.335c3.912-.666 7.076-3.113 8.826-6.36h-3.855zM244.107 3.362a9.15 9.15 0 0 1 6.854 1.56 9.12 9.12 0 0 1 3.741 5.954l3.532 20.734h3.265l-3.62-21.28a12.36 12.36 0 0 0-5.054-8.04 12.33 12.33 0 0 0-9.257-2.11L141.724 17.514a12.36 12.36 0 0 0-8.039 5.053 12.4 12.4 0 0 0-2.201 5.713h3.253a9.14 9.14 0 0 1 1.573-3.855 9.12 9.12 0 0 1 5.953-3.741L244.107 3.35z"/>
  </g>
  <defs>
    <clipPath id="scorecard-logo-plus-light-horizontal-none_svg__a">
      <path fill="#fff" d="M0 0h296v100H0z"/>
    </clipPath>
  </defs>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardPlusDarkHorizontal = {
  name: 'scorecard-plus-dark-horizontal',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="294" height="100" fill="none" viewBox="0 0 294 100">
  <g fill="#161313" clip-path="url(#scorecard-plus-dark-horizontal_svg__a)">
    <path d="M263.148 77.14a12.23 12.23 0 0 1-8.304 5.548L154.168 99.825c-.703.12-1.399.175-2.088.175-2.513 0-4.97-.778-7.064-2.263a12.22 12.22 0 0 1-4.995-7.948l-1.405-8.235h3.23l1.308 7.702a9.02 9.02 0 0 0 3.699 5.886 9.03 9.03 0 0 0 6.775 1.542l100.677-17.136a9.05 9.05 0 0 0 4.762-2.408z"/>
    <path fill-rule="evenodd" d="M82.023 38.856v33.095l-5.46 5.459H62.126l-5.459-5.46V38.857l5.46-5.46h14.434zM66.289 69.662h6.105V41.143H66.29z" clip-rule="evenodd"/>
    <path d="M135.526 41.614h-11.383v9.389h10.505v8.218h-10.505v9.971h11.383v8.218h-21.004V33.396h21.004zM25.398 38.849v9.152h-9.622v-6.864h-5.93v7.98l10.8 3.522 4.813 5.165v14.14L20 77.405H5.916l-5.46-5.46V62.5h9.622v7.157h5.986v-8.273L5.27 57.803.457 52.64v-13.79l5.459-5.46h14.022zM53.565 38.849v10.267h-9.62v-7.979h-5.748v28.52h5.747v-8.8h9.621v11.088l-5.46 5.459H34.023l-5.46-5.46V38.85l5.46-5.46h14.084z"/>
    <path fill-rule="evenodd" d="M110.83 38.856v13.375l-4.105 4.106 4.105 4.106v16.955h-9.621V59.973h-5.868v17.425h-9.62l-.007.006V33.396h19.657zM95.335 52.702h5.867V41.143h-5.867z" clip-rule="evenodd"/>
    <path d="M163.694 38.849v10.267h-9.621v-7.979h-5.747v28.52h5.747v-8.8h9.621v11.088l-5.459 5.459h-14.084l-5.46-5.46V38.85l5.46-5.46h14.084z"/>
    <path fill-rule="evenodd" d="M193.737 77.404h-9.86l-1.347-9.327h-7.045l-1.348 9.327h-8.92l7.397-44.008h13.727zm-17.012-17.776h4.57l-2.169-14.668h-.232zM221.428 38.856v13.375l-4.105 4.106 4.105 4.106v16.955h-9.621V59.973h-5.866v17.425h-9.621l-.006.006V33.396h19.656zm-15.487 13.846h5.866V41.143h-5.866zM250.293 38.792v33.096l-5.461 5.46h-19.711V33.332h19.711zM234.742 69.6h5.928V41.08h-5.928z" clip-rule="evenodd"/>
    <path d="M279.012 50.617h14.815v9.877h-14.815v14.814h-9.876V60.494h-14.815v-9.877h14.815V35.802h9.876zM240.998 1.342a12.19 12.19 0 0 1 9.151 2.087 12.2 12.2 0 0 1 4.995 7.948l3.736 21.956h-3.228l-3.647-21.43a9.01 9.01 0 0 0-3.699-5.885 9.04 9.04 0 0 0-6.775-1.542L140.854 21.612a9.01 9.01 0 0 0-5.886 3.699 9 9 0 0 0-1.554 3.811h-3.215c.238-2.012.971-3.95 2.175-5.648a12.22 12.22 0 0 1 7.947-4.995z"/>
  </g>
  <defs>
    <clipPath id="scorecard-plus-dark-horizontal_svg__a">
      <path fill="#fff" d="M0 0h293.827v100H0z"/>
    </clipPath>
  </defs>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardPlusLightHorizontal = {
  name: 'scorecard-plus-light-horizontal',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="294" height="100" fill="none" viewBox="0 0 294 100">
  <g fill="#fff" clip-path="url(#scorecard-plus-light-horizontal_svg__a)">
    <path d="M263.148 77.14a12.23 12.23 0 0 1-8.304 5.548L154.168 99.825c-.703.12-1.399.175-2.088.175a12.2 12.2 0 0 1-7.064-2.263 12.22 12.22 0 0 1-4.995-7.948l-1.405-8.235h3.23l1.308 7.702a9.02 9.02 0 0 0 3.699 5.886 9.03 9.03 0 0 0 6.775 1.542l100.677-17.136a9.05 9.05 0 0 0 4.762-2.408z"/>
    <path fill-rule="evenodd" d="M82.023 38.856v33.095l-5.46 5.459H62.126l-5.459-5.46V38.857l5.46-5.46h14.434zM66.289 69.662h6.105V41.143H66.29z" clip-rule="evenodd"/>
    <path d="M135.526 41.613h-11.383v9.39h10.505v8.218h-10.505v9.971h11.383v8.218h-21.004V33.396h21.004zM25.398 38.849v9.152h-9.622v-6.864h-5.93v7.98l10.8 3.522 4.813 5.165v14.14L20 77.405H5.916l-5.46-5.46V62.5h9.622v7.157h5.986v-8.273L5.27 57.803.457 52.64v-13.79l5.459-5.46h14.022zM53.565 38.849v10.267h-9.62v-7.979h-5.748v28.52h5.747v-8.8h9.621v11.088l-5.46 5.459H34.023l-5.46-5.46V38.85l5.46-5.46h14.084z"/>
    <path fill-rule="evenodd" d="M110.83 38.856v13.375l-4.105 4.106 4.105 4.106v16.955h-9.621V59.973h-5.868v17.425h-9.62l-.007.006V33.396h19.657zM95.335 52.702h5.867V41.143h-5.867z" clip-rule="evenodd"/>
    <path d="M163.694 38.849v10.267h-9.621v-7.979h-5.747v28.52h5.747v-8.8h9.621v11.088l-5.459 5.459h-14.084l-5.46-5.46V38.85l5.46-5.46h14.084z"/>
    <path fill-rule="evenodd" d="M193.737 77.404h-9.86l-1.347-9.327h-7.045l-1.348 9.327h-8.92l7.397-44.008h13.727zm-17.012-17.776h4.57l-2.169-14.668h-.232zM221.428 38.856v13.375l-4.105 4.106 4.105 4.106v16.955h-9.621V59.973h-5.866v17.425h-9.621l-.006.006V33.396h19.656zm-15.487 13.846h5.866V41.143h-5.866zM250.293 38.792v33.096l-5.461 5.46h-19.711V33.332h19.711zM234.742 69.6h5.928V41.08h-5.928z" clip-rule="evenodd"/>
    <path d="M279.012 50.617h14.815v9.877h-14.815v14.814h-9.876V60.494h-14.815v-9.877h14.815V35.802h9.876zM240.998 1.342a12.19 12.19 0 0 1 9.151 2.087 12.2 12.2 0 0 1 4.995 7.948l3.736 21.956h-3.228l-3.647-21.43a9.01 9.01 0 0 0-3.699-5.885 9.04 9.04 0 0 0-6.775-1.542L140.854 21.612a9.01 9.01 0 0 0-5.886 3.699 9 9 0 0 0-1.554 3.81h-3.215c.238-2.011.971-3.949 2.175-5.647a12.22 12.22 0 0 1 7.947-4.995z"/>
  </g>
  <defs>
    <clipPath id="scorecard-plus-light-horizontal_svg__a">
      <path fill="#fff" d="M0 0h293.827v100H0z"/>
    </clipPath>
  </defs>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardPlusLightStacked = {
  name: 'scorecard-plus-light-stacked',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="127" height="100" fill="none" viewBox="0 0 127 100">
  <g fill="#fff" clip-path="url(#scorecard-plus-light-stacked_svg__a)">
    <path d="M24.245 37.005h5.587v4.157h3.476v-4.806l-6.27-2.079-2.793-2.993v-8.016l3.176-3.16h8.132l3.176 3.16v5.322h-5.587v-3.991h-3.443v4.64l6.27 2.045 2.794 2.993v8.215l-3.177 3.16h-8.165l-3.176-3.16zM55.06 29.239h-5.588v-4.64H46.13v16.563h3.342V36.04h5.588v6.453l-3.176 3.16h-8.166l-3.176-3.16V23.268l3.176-3.16h8.166l3.176 3.16zM65.97 41.162V24.6h-3.543v16.563zm-5.954 4.49-3.177-3.16V23.269l3.177-3.16h8.381l3.16 3.16v19.225l-3.16 3.16zM79.307 45.652h-5.588V20.11h11.408l3.16 3.16v7.766l-2.379 2.394 2.378 2.378v9.845H82.7v-10.11h-3.392zm3.392-14.335V24.6h-3.392v6.718zM90.449 45.652V20.11h12.189v4.772h-6.602v5.438h6.086v4.773h-6.086v5.787h6.602v4.773zM32.508 58.678h-6.42v-5.33h-3.84v19.03h3.84v-5.885h6.42v7.413l-3.649 3.63h-9.381l-3.65-3.63V51.819l3.65-3.63h9.381l3.65 3.63zM45.96 77.536l-.898-6.228h-4.7l-.899 6.228h-5.961l4.949-29.348h9.152l4.93 29.348zm-3.325-21.648-1.452 9.783h3.057l-1.452-9.783zM60.672 77.536h-6.42V48.188h13.107l3.63 3.63v8.924l-2.732 2.75 2.732 2.733v11.311h-6.42V65.92h-3.897zm3.897-16.47v-7.719h-3.897v7.72zM83.829 72.378v-19.03h-3.936v19.03zm-10.356 5.158V48.188h13.145l3.63 3.63v22.088l-3.63 3.63zM100.933 75.362v-9.42h-9.42v-7.246h9.42v-9.42h7.246v9.42h9.42v7.246h-9.42v9.42z"/>
    <path d="M102.859.409c6.315-1.057 12.292 3.206 13.348 9.521l9.831 58.75c1.057 6.315-3.205 12.291-9.521 13.348L23.341 97.62l-.296.046c-6.107.863-11.828-3.217-13-9.272l-.053-.295L.161 29.35c-1.057-6.315 3.206-12.292 9.521-13.349zm10.49 10a8.697 8.697 0 0 0-10.012-7.141L10.161 18.86A8.696 8.696 0 0 0 3.02 28.871l9.831 58.75a8.695 8.695 0 0 0 10.011 7.14l93.176-15.592a8.696 8.696 0 0 0 7.142-10.011z"/>
  </g>
  <defs>
    <clipPath id="scorecard-plus-light-stacked_svg__a">
      <path fill="#fff" d="M0 0h126.812v100H0z"/>
    </clipPath>
  </defs>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardPlusPoints = {
  name: 'scorecard-plus-points',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="61" height="50" fill="none" viewBox="0 0 61 50">
  <path fill="var(--hmf-icon-color, #161313)" d="M0 32.813h10.705v8.658h6.887V28.678H9.236v-8.821h8.356V8.529h-6.887v7.747H0V6.055L6.103 0h16.09l6.071 6.055v13.541l-4.667 4.655 4.667 4.688v15.006L22.194 50H6.104L0 43.945zM41.222 50H30.255l6.038-26.14L30.614 0h11.293l3.655 18.457h.229L50 0h10.673l-5.68 23.86L61 50H49.707l-3.85-19.727h-.23z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconScorecardPlusRewards = {
  name: 'scorecard-plus-rewards',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="50" fill="none" viewBox="0 0 80 50">
  <path fill="var(--hmf-icon-color, #161313)" d="M30.183 41.55h7.163V28.584h-7.163zm0-21.159h7.163V8.91h-7.163zM25.613 50l-6.06-6V29.133l4.667-4.645-4.668-4.612V6.458l6.061-6H41.95l6.028 6v13.417l-4.634 4.613 4.634 4.644v14.869L41.95 50zM69.369 41.485V8.91h-6.904v32.576zM57.895 50l-6.06-6V6.459l6.06-6H73.94l6.061 6V44L73.939 50zM10.737 32.875v3.516H6.185v-3.516H3.592L0 29.32v-6.384h6.454v4.931h4.014V22.19l-7.241-2.389L0 16.361V7.07l3.592-3.554h2.593V0h4.552v3.517h2.4l3.592 3.555v6.193h-6.453v-4.74H6.3v5.485l7.24 2.35 3.228 3.441v9.519l-3.592 3.555z"/>
</svg>
`,
};
/** @deprecated This icon was removed from v9. Migrate to the nearest v9 equivalent. */
export const homefieldIconSignCircle = {
  name: 'sign-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="10" fill="var(--hmf-icon-color, #191F1C)"/>
</svg>
`,
};
